/**
 * @generated
 *
 * DO NOT EDIT MANUALLY.
 * Re-run:
 *   node scripts/automated/generate-recomposed-rtk-operation-map.mjs
 *
 * GeneratorVersion: rtk-semantic-operation-manifest-v1
 *
 * Inputs:
 * - config/domain-router/semantic-operation-runtime-bindings.json
 * - config/semantic-routes/admissions.json
 * - config/semantic-routes/financial-aid.json
 * - config/semantic-routes/payroll.json
 * - config/semantic-routes/settings.json
 * - config/semantic-routes/parent-portal.json
 * - config/semantic-routes/students-families.json
 * - config/semantic-routes/faculty.json
 * - config/semantic-routes/school-tuition.json
 * - config/semantic-routes/run-reports.json
 *
 * SelectedModules: admissions,financial-aid,payroll,settings,parent-portal,students-families,faculty,school-tuition,run-reports
 * Summary: total=284 resolved=284 unresolved=0
 */

import type {
  YstnjSemanticOperationManifestEntry,
  YstnjAwsJsonFieldShapeMap,
} from "./ystnj-semantic-operation-manifest";

export const ystnjSemanticOperationManifest: readonly YstnjSemanticOperationManifestEntry[] =
  Object.freeze([
    {
      id: "admissions-dashboard::Admissions.listApplications",
      moduleId: "admissions",
      routeId: "admissions-dashboard",
      semanticPath: "/admin/admissions/staff/dashboard",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.listApplications",
      notes: "List projection with filter/sort/pagination semantics.",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions runtime access is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "listApplications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "listApplications",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {
          limit: 25,
        },
      },
    },
    {
      id: "admissions-dashboard::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-dashboard",
      semanticPath: "/admin/admissions/staff/dashboard",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions runtime access is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "admissions-dashboard::DomainCore.markNotificationRead",
      moduleId: "admissions",
      routeId: "admissions-dashboard",
      semanticPath: "/admin/admissions/staff/dashboard",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions runtime access is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-detail::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-detail::Admissions.addInternalNote",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "addNote",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "addNote",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-detail::Admissions.attachDocument",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.attachDocument",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "addDocument",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "addDocument",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-detail::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "admissions-applicant-detail::DomainCore.getNotification",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-detail::DomainCore.markNotificationRead",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-children::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-children",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/children",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant children is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-children::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-applicant-children",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/children",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant children is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "admissions-applicant-family::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-family",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/family",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant family is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-tuition::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-tuition::Admissions.getAdmissionsTuitionConfiguration",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getAdmissionsTuitionConfiguration",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getAdmissionsTuitionConfiguration",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getAdmissionsTuitionConfiguration",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "admissions-applicant-tuition::Admissions.upsertAdmissionsTuitionConfiguration",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.upsertAdmissionsTuitionConfiguration",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "upsertAdmissionsTuitionConfiguration",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "upsertAdmissionsTuitionConfiguration",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-tuition::Admissions.generateTuitionContract",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.generateTuitionContract",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "generateTuitionContract",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "generateTuitionContract",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-tuition::Admissions.sendTuitionContract",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.sendTuitionContract",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "sendTuitionContract",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "sendTuitionContract",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-tuition::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "admissions-applicant-documents::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-documents",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/documents",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant documents is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-documents::Admissions.attachDocument",
      moduleId: "admissions",
      routeId: "admissions-applicant-documents",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/documents",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.attachDocument",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant documents is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "addDocument",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "addDocument",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-documents::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-applicant-documents",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/documents",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant documents is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "admissions-applicant-notes::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-notes",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/notes",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant notes is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-notes::Admissions.addInternalNote",
      moduleId: "admissions",
      routeId: "admissions-applicant-notes",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/notes",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant notes is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "addNote",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "addNote",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-notes::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-applicant-notes",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/notes",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant notes is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-dashboard::FinancialAid.listApplications",
      moduleId: "financial-aid",
      routeId: "fa-staff-dashboard",
      semanticPath: "/admin/financial-aid/staff/dashboard",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.listApplications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid dashboard is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "listFinancialAidApplicationsForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "listFinancialAidApplicationsForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "fa-staff-dashboard::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-dashboard",
      semanticPath: "/admin/financial-aid/staff/dashboard",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid dashboard is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-dashboard::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-dashboard",
      semanticPath: "/admin/financial-aid/staff/dashboard",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid dashboard is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-dashboard::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-dashboard",
      semanticPath: "/admin/financial-aid/staff/dashboard",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid dashboard is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-help::FinancialAid.getFinancialAidDocumentStatus",
      moduleId: "financial-aid",
      routeId: "fa-staff-help",
      semanticPath: "/admin/financial-aid/staff/help",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getFinancialAidDocumentStatus",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid help is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidDocumentStatus",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidDocumentStatus",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-help::FinancialAid.uploadFinancialAidDocument",
      moduleId: "financial-aid",
      routeId: "fa-staff-help",
      semanticPath: "/admin/financial-aid/staff/help",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.uploadFinancialAidDocument",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid help is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "uploadFinancialAidDocument",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "uploadFinancialAidDocument",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-dashboard::Payroll.getDashboard",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "query",
      op: "Payroll.getDashboard",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "getPayrollDashboard",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "PayrollTransport",
        rootField: "domainPayrollQuery",
        document:
          "query PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollQuery",
          operationId: "getPayrollDashboard",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "payroll-dashboard::Payroll.switchPeriod",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.switchPeriod",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "switchPayrollPeriod",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "switchPayrollPeriod",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-dashboard::Payroll.submitForApproval",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.submitForApproval",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "submitPayrollPeriodForApproval",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "submitPayrollPeriodForApproval",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-dashboard::Payroll.approvePeriod",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.approvePeriod",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "approvePayrollPeriod",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "approvePayrollPeriod",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-dashboard::Payroll.rejectPeriod",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.rejectPeriod",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "rejectPayrollPeriod",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "rejectPayrollPeriod",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-dashboard::Payroll.unlockPeriod",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.unlockPeriod",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "unlockPayrollPeriod",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "unlockPayrollPeriod",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-dashboard::Payroll.exportPeriod",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.exportPeriod",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "exportPayrollPeriod",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "exportPayrollPeriod",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-employee-detail::Payroll.getEmployeeDetail",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "query",
      op: "Payroll.getEmployeeDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "getPayrollEmployeeDetail",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "PayrollTransport",
        rootField: "domainPayrollQuery",
        document:
          "query PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollQuery",
          operationId: "getPayrollEmployeeDetail",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "payroll-employee-detail::Payroll.listAuditLog",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "query",
      op: "Payroll.listAuditLog",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "listPayrollAuditLog",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "PayrollTransport",
        rootField: "domainPayrollQuery",
        document:
          "query PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollQuery",
          operationId: "listPayrollAuditLog",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "payroll-employee-detail::Payroll.updateEmployeeProfile",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateEmployeeProfile",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollEmployeeProfile",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollEmployeeProfile",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-employee-detail::Payroll.updatePosition",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updatePosition",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollPosition",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollPosition",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-employee-detail::Payroll.updateStipend",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateStipend",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollStipend",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollStipend",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-employee-detail::Payroll.updateTimeEntry",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateTimeEntry",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollTimeEntry",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollTimeEntry",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-employee-detail::Payroll.updateAdjustment",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateAdjustment",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollAdjustment",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollAdjustment",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-employee-detail::Payroll.updateExternalTuitionPayment",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateExternalTuitionPayment",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollExternalTuitionPayment",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollExternalTuitionPayment",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "payroll-employee-detail::Payroll.updateDeductionEntry",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateDeductionEntry",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollDeductionEntry",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollDeductionEntry",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-general::StaffSettings.getGeneralSettings",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.getGeneralSettings",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "getModuleConfig",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetModuleConfig",
        rootField: "getModuleConfig",
        document:
          "query GetModuleConfig($orgId: String, $moduleKey: String!) {\n  getModuleConfig(orgId: $orgId, moduleKey: $moduleKey) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        defaultVariables: {
          moduleKey: "settings.general",
        },
        requiredVariables: ["moduleKey"],
      },
    },
    {
      id: "settings-general::StaffSettings.updateGeneralSettings",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.updateGeneralSettings",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "updateModuleConfig",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateModuleConfig",
        rootField: "updateModuleConfig",
        document:
          "mutation UpdateModuleConfig($input: AWSJSON!) {\n  updateModuleConfig(input: $input) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-general::StaffSettings.listModuleEnablementAuditEvents",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.listModuleEnablementAuditEvents",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "listModuleEnablementAuditEvents",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "SettingsTransport",
        rootField: "domainSettingsQuery",
        document:
          "query SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsQuery",
          operationId: "listModuleEnablementAuditEvents",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {
          limit: 5,
        },
      },
    },
    {
      id: "settings-general::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "settings-general::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "settings-general::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "control-plane-integrations::StaffSettings.getIntegrationsStatus",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "StaffSettings.getIntegrationsStatus",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantIntegrationsApi",
        operationId: "getAssistantSpreadsheetBridgeStatus",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantIntegrationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantIntegrationsTransport",
        rootField: "assistantIntegrationsQuery",
        document:
          "query AssistantIntegrationsTransport($operationId: String!, $input: AWSJSON) {\n  assistantIntegrationsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantIntegrationsQuery",
          operationId: "getAssistantSpreadsheetBridgeStatus",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "control-plane-integrations::Payments.getControlPlaneReadiness",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "Payments.getControlPlaneReadiness",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPaymentsApi",
        operationId: "getPaymentControlPlaneReadiness",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "PaymentsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "PaymentsTransport",
        rootField: "domainPaymentsQuery",
        document:
          "query PaymentsTransport($operationId: String!, $input: AWSJSON) {\n  domainPaymentsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPaymentsQuery",
          operationId: "getPaymentControlPlaneReadiness",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "control-plane-integrations::Payments.startConnectedAccountOnboarding",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "Payments.startConnectedAccountOnboarding",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPaymentsApi",
        operationId: "startStripeConnectedAccountOnboarding",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "PaymentsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PaymentsTransport",
        rootField: "domainPaymentsMutation",
        document:
          "mutation PaymentsTransport($operationId: String!, $input: AWSJSON) {\n  domainPaymentsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPaymentsMutation",
          operationId: "startStripeConnectedAccountOnboarding",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "control-plane-integrations::Payments.completeConnectedAccountOnboarding",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "Payments.completeConnectedAccountOnboarding",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPaymentsApi",
        operationId: "completeStripeConnectedAccountOnboarding",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "PaymentsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PaymentsTransport",
        rootField: "domainPaymentsMutation",
        document:
          "mutation PaymentsTransport($operationId: String!, $input: AWSJSON) {\n  domainPaymentsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPaymentsMutation",
          operationId: "completeStripeConnectedAccountOnboarding",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "control-plane-integrations::Payments.updateControlPlane",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "Payments.updateControlPlane",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPaymentsApi",
        operationId: "updatePaymentControlPlane",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "PaymentsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PaymentsTransport",
        rootField: "domainPaymentsMutation",
        document:
          "mutation PaymentsTransport($operationId: String!, $input: AWSJSON) {\n  domainPaymentsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPaymentsMutation",
          operationId: "updatePaymentControlPlane",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "control-plane-integrations::StaffSettings.startGoogleSheetsOauthBridge",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "StaffSettings.startGoogleSheetsOauthBridge",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantIntegrationsApi",
        operationId: "startAssistantSpreadsheetBridgeAuth",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantIntegrationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantIntegrationsTransport",
        rootField: "assistantIntegrationsMutation",
        document:
          "mutation AssistantIntegrationsTransport($operationId: String!, $input: AWSJSON) {\n  assistantIntegrationsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantIntegrationsMutation",
          operationId: "startAssistantSpreadsheetBridgeAuth",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["redirectUri"],
      },
    },
    {
      id: "control-plane-integrations::StaffSettings.finalizeGoogleSheetsOauthBridge",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "StaffSettings.finalizeGoogleSheetsOauthBridge",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantIntegrationsApi",
        operationId: "completeAssistantSpreadsheetBridgeAuth",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantIntegrationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantIntegrationsTransport",
        rootField: "assistantIntegrationsMutation",
        document:
          "mutation AssistantIntegrationsTransport($operationId: String!, $input: AWSJSON) {\n  assistantIntegrationsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantIntegrationsMutation",
          operationId: "completeAssistantSpreadsheetBridgeAuth",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["code", "state"],
      },
    },
    {
      id: "control-plane-integrations::StaffSettings.exportAssistantSpreadsheetToDrive",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "StaffSettings.exportAssistantSpreadsheetToDrive",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantIntegrationsApi",
        operationId: "exportAssistantSpreadsheetToGoogleDrive",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantIntegrationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantIntegrationsTransport",
        rootField: "assistantIntegrationsMutation",
        document:
          "mutation AssistantIntegrationsTransport($operationId: String!, $input: AWSJSON) {\n  assistantIntegrationsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantIntegrationsMutation",
          operationId: "exportAssistantSpreadsheetToGoogleDrive",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["fileName"],
      },
    },
    {
      id: "control-plane-integrations::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "control-plane-integrations::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "control-plane-integrations::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-assistant-workflow::AssistantPlatform.listAssistantWorkflowTemplates",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "AssistantPlatform.listAssistantWorkflowTemplates",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "listAssistantWorkflowTemplates",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "listAssistantWorkflowTemplates",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "settings-assistant-workflow::AssistantPlatform.getAssistantWorkflow",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "AssistantPlatform.getAssistantWorkflow",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "getAssistantWorkflow",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "getAssistantWorkflow",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "settings-assistant-workflow::AssistantPlatform.listAssistantWorkflowExecutions",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "AssistantPlatform.listAssistantWorkflowExecutions",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "listAssistantWorkflowExecutions",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "listAssistantWorkflowExecutions",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "settings-assistant-workflow::AssistantPlatform.upsertAssistantWorkflowDraft",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "AssistantPlatform.upsertAssistantWorkflowDraft",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "upsertAssistantWorkflowDraft",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "upsertAssistantWorkflowDraft",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-assistant-workflow::AssistantPlatform.submitAssistantWorkflowForApproval",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "AssistantPlatform.submitAssistantWorkflowForApproval",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "submitAssistantWorkflowForApproval",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "submitAssistantWorkflowForApproval",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-assistant-workflow::AssistantPlatform.reviewAssistantWorkflow",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "AssistantPlatform.reviewAssistantWorkflow",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "reviewAssistantWorkflow",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "reviewAssistantWorkflow",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-assistant-workflow::AssistantPlatform.mutateAssistantRun",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "AssistantPlatform.mutateAssistantRun",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "mutateAssistantRun",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "mutateAssistantRun",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-assistant-workflow::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "settings-assistant-workflow::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "settings-assistant-workflow::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::StaffSettings.listUsers",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.listUsers",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "listStaffUsers",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "SettingsTransport",
        rootField: "domainSettingsQuery",
        document:
          "query SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsQuery",
          operationId: "listStaffUsers",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "settings-users::StaffSettings.updateUserRoles",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.updateUserRoles",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "updateStaffUserRole",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "updateStaffUserRole",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::StaffSettings.inviteUser",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.inviteUser",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "inviteStaffUser",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "inviteStaffUser",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::StaffSettings.resendInvite",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.resendInvite",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "resendStaffInvite",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "resendStaffInvite",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::StaffSettings.suspendUser",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.suspendUser",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "deactivateStaffUser",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "deactivateStaffUser",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::StaffSettings.reactivateUser",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.reactivateUser",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "reactivateStaffUser",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "reactivateStaffUser",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::StaffSettings.listStaffCodes",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.listStaffCodes",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "listStaffCodes",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "SettingsTransport",
        rootField: "domainSettingsQuery",
        document:
          "query SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsQuery",
          operationId: "listStaffCodes",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "settings-users::StaffSettings.createStaffCode",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.createStaffCode",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "createStaffCode",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "createStaffCode",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::StaffSettings.rotateStaffCode",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.rotateStaffCode",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "rotateStaffCode",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "rotateStaffCode",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::StaffSettings.revokeStaffCode",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.revokeStaffCode",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "revokeStaffCode",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "revokeStaffCode",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::StaffSettings.listApprovedDomains",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.listApprovedDomains",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "listApprovedDomains",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "SettingsTransport",
        rootField: "domainSettingsQuery",
        document:
          "query SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsQuery",
          operationId: "listApprovedDomains",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "settings-users::StaffSettings.addApprovedDomain",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.addApprovedDomain",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "addApprovedDomain",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "addApprovedDomain",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::StaffSettings.removeApprovedDomain",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.removeApprovedDomain",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "removeApprovedDomain",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "removeApprovedDomain",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "settings-users::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "settings-users::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-admissions::StaffSettings.getAdmissionsSettings",
      moduleId: "settings",
      routeId: "settings-admissions",
      semanticPath: "/admin/settings/staff/admissions",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.getAdmissionsSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "getModuleConfig",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetModuleConfig",
        rootField: "getModuleConfig",
        document:
          "query GetModuleConfig($orgId: String, $moduleKey: String!) {\n  getModuleConfig(orgId: $orgId, moduleKey: $moduleKey) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        defaultVariables: {
          moduleKey: "settings.admissions",
        },
        requiredVariables: ["moduleKey"],
      },
    },
    {
      id: "settings-admissions::StaffSettings.updateAdmissionsSettings",
      moduleId: "settings",
      routeId: "settings-admissions",
      semanticPath: "/admin/settings/staff/admissions",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.updateAdmissionsSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "updateModuleConfig",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateModuleConfig",
        rootField: "updateModuleConfig",
        document:
          "mutation UpdateModuleConfig($input: AWSJSON!) {\n  updateModuleConfig(input: $input) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-admissions::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "settings-admissions",
      semanticPath: "/admin/settings/staff/admissions",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "settings-admissions::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-admissions",
      semanticPath: "/admin/settings/staff/admissions",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "settings-admissions::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-admissions",
      semanticPath: "/admin/settings/staff/admissions",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-financial-aid::StaffSettings.getFinancialAidSettings",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.getFinancialAidSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "getModuleConfig",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetModuleConfig",
        rootField: "getModuleConfig",
        document:
          "query GetModuleConfig($orgId: String, $moduleKey: String!) {\n  getModuleConfig(orgId: $orgId, moduleKey: $moduleKey) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        defaultVariables: {
          moduleKey: "staff_settings",
        },
        requiredVariables: ["moduleKey"],
      },
    },
    {
      id: "settings-financial-aid::StaffSettings.updateFinancialAidSettings",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.updateFinancialAidSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "updateModuleConfig",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateModuleConfig",
        rootField: "updateModuleConfig",
        document:
          "mutation UpdateModuleConfig($input: AWSJSON!) {\n  updateModuleConfig(input: $input) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-financial-aid::StaffSettings.getFinancialAidImportTemplate",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.getFinancialAidImportTemplate",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "getFinancialAidHistoricalImportTemplate",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFinancialAidHistoricalImportTemplate",
        rootField: "getFinancialAidHistoricalImportTemplate",
        document:
          "query GetFinancialAidHistoricalImportTemplate($moduleKey: String, $orgId: String) {\n  getFinancialAidHistoricalImportTemplate(moduleKey: $moduleKey, orgId: $orgId) {\n    downloadUrl\n    templateVersion\n    fileName\n    expiresAt\n  }\n}",
        defaultVariables: {
          moduleKey: "staff_settings",
        },
      },
    },
    {
      id: "settings-financial-aid::StaffSettings.requestFinancialAidImportUpload",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.requestFinancialAidImportUpload",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "requestFinancialAidHistoricalImportUpload",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFinancialAidHistoricalImportUpload",
        rootField: "requestFinancialAidHistoricalImportUpload",
        document:
          "mutation RequestFinancialAidHistoricalImportUpload($input: AWSJSON!) {\n  requestFinancialAidHistoricalImportUpload(input: $input) {\n    importId\n    uploadUrl\n    s3Key\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-financial-aid::StaffSettings.startFinancialAidImport",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.startFinancialAidImport",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "startFinancialAidHistoricalImport",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StartFinancialAidHistoricalImport",
        rootField: "startFinancialAidHistoricalImport",
        document:
          "mutation StartFinancialAidHistoricalImport($input: AWSJSON!) {\n  startFinancialAidHistoricalImport(input: $input) {\n    status\n    importId\n    templateVersion\n    lastFileName\n    lastS3Key\n    lastImportedAt\n    processedRows\n    acceptedRows\n    rejectedRows\n    errorSummary\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-financial-aid::StaffSettings.getFinancialAidImportStatus",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.getFinancialAidImportStatus",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "getFinancialAidHistoricalImportStatus",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFinancialAidHistoricalImportStatus",
        rootField: "getFinancialAidHistoricalImportStatus",
        document:
          "query GetFinancialAidHistoricalImportStatus($importId: String, $moduleKey: String, $orgId: String) {\n  getFinancialAidHistoricalImportStatus(importId: $importId, moduleKey: $moduleKey, orgId: $orgId) {\n    status\n    importId\n    templateVersion\n    lastFileName\n    lastS3Key\n    lastImportedAt\n    processedRows\n    acceptedRows\n    rejectedRows\n    errorSummary\n  }\n}",
        defaultVariables: {
          moduleKey: "staff_settings",
        },
      },
    },
    {
      id: "settings-financial-aid::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "settings-financial-aid::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "settings-financial-aid::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-dashboard::ParentPortal.listFamilies",
      moduleId: "parent-portal",
      routeId: "portal-family-dashboard",
      semanticPath: "/portal/family/dashboard",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.listFamilies",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent dashboard route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-dashboard::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-dashboard",
      semanticPath: "/portal/family/dashboard",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent dashboard route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-dashboard::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-dashboard",
      semanticPath: "/portal/family/dashboard",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent dashboard route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-shell::ParentPortal.getDashboardShell",
      moduleId: "parent-portal",
      routeId: "portal-family-shell",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getDashboardShell",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-shell::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-shell",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-shell::DomainCore.markAllNotificationsRead",
      moduleId: "parent-portal",
      routeId: "portal-family-shell",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markAllNotificationsRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markAllNotificationsRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkAllNotificationsRead",
        rootField: "markAllNotificationsRead",
        document:
          "mutation MarkAllNotificationsRead($input: AWSJSON!) {\n  markAllNotificationsRead(input: $input) {\n    updatedCount\n    unreadCount\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-applications::ParentPortal.listApplications",
      moduleId: "parent-portal",
      routeId: "portal-family-applications",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.listApplications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent tuition route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-applications::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-applications",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent tuition route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-applications::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-applications",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent tuition route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-enrollment::ParentPortal.getEnrollmentStatus",
      moduleId: "parent-portal",
      routeId: "portal-family-enrollment",
      semanticPath: "/portal/family/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getEnrollmentStatus",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-enrollment::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-enrollment",
      semanticPath: "/portal/family/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-enrollment::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-enrollment",
      semanticPath: "/portal/family/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-financial-aid::ParentPortal.getFinancialAidStatus",
      moduleId: "parent-portal",
      routeId: "portal-family-financial-aid",
      semanticPath: "/portal/family/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getFinancialAidStatus",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidParentStatusView",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidParentStatusView",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "portal-family-financial-aid::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-financial-aid",
      semanticPath: "/portal/family/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-financial-aid::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-financial-aid",
      semanticPath: "/portal/family/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-settings::ParentPortal.getSettings",
      moduleId: "parent-portal",
      routeId: "portal-family-settings",
      semanticPath: "/portal/family/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-settings::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-settings",
      semanticPath: "/portal/family/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-settings::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-settings",
      semanticPath: "/portal/family/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-calendar::ParentPortal.getCalendarEvents",
      moduleId: "parent-portal",
      routeId: "portal-family-calendar",
      semanticPath: "/portal/family/calendar",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getCalendarEvents",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent calendar route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalCalendarEvents",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalCalendarEvents",
        rootField: "listPortalCalendarEvents",
        document:
          "query ListPortalCalendarEvents($input: AWSJSON) {\n  listPortalCalendarEvents(input: $input) {\n    id\n    title\n    startDate\n    endDate\n    location\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-calendar::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-calendar",
      semanticPath: "/portal/family/calendar",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent calendar route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-calendar::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-calendar",
      semanticPath: "/portal/family/calendar",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent calendar route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-attendance::ParentPortal.getAttendanceSummary",
      moduleId: "parent-portal",
      routeId: "portal-family-attendance",
      semanticPath: "/portal/family/attendance",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getAttendanceSummary",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent attendance route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-attendance::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-attendance",
      semanticPath: "/portal/family/attendance",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent attendance route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-attendance::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-attendance",
      semanticPath: "/portal/family/attendance",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent attendance route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-academic::ParentPortal.getAcademicSummary",
      moduleId: "parent-portal",
      routeId: "portal-family-academic",
      semanticPath: "/portal/family/academic",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getAcademicSummary",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent academic route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-academic::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-academic",
      semanticPath: "/portal/family/academic",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent academic route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-academic::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-academic",
      semanticPath: "/portal/family/academic",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent academic route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-resources::ParentPortal.listResources",
      moduleId: "parent-portal",
      routeId: "portal-family-resources",
      semanticPath: "/portal/family/resources",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.listResources",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent resources route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalResources",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalResources",
        rootField: "listPortalResources",
        document:
          "query ListPortalResources($input: AWSJSON) {\n  listPortalResources(input: $input) {\n    id\n    title\n    category\n    updatedAt\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-resources::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-resources",
      semanticPath: "/portal/family/resources",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent resources route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-resources::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-resources",
      semanticPath: "/portal/family/resources",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent resources route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-new-family-applications::ParentPortal.getIntakeApplications",
      moduleId: "parent-portal",
      routeId: "portal-new-family-applications",
      semanticPath: "/portal/family/intake/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getIntakeApplications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake applications route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[10]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-new-family-applications::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-new-family-applications",
      semanticPath: "/portal/family/intake/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake applications route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[10]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-new-family-applications::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-new-family-applications",
      semanticPath: "/portal/family/intake/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake applications route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[10]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-new-family-enrollment::ParentPortal.getIntakeEnrollment",
      moduleId: "parent-portal",
      routeId: "portal-new-family-enrollment",
      semanticPath: "/portal/family/intake/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getIntakeEnrollment",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[11]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-new-family-enrollment::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-new-family-enrollment",
      semanticPath: "/portal/family/intake/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[11]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-new-family-enrollment::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-new-family-enrollment",
      semanticPath: "/portal/family/intake/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[11]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-new-family-financial-aid::ParentPortal.getIntakeFinancialAid",
      moduleId: "parent-portal",
      routeId: "portal-new-family-financial-aid",
      semanticPath: "/portal/family/intake/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getIntakeFinancialAid",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[12]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidParentStatusView",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidParentStatusView",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "portal-new-family-financial-aid::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-new-family-financial-aid",
      semanticPath: "/portal/family/intake/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[12]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-new-family-financial-aid::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-new-family-financial-aid",
      semanticPath: "/portal/family/intake/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[12]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-new-family-settings::ParentPortal.getIntakeSettings",
      moduleId: "parent-portal",
      routeId: "portal-new-family-settings",
      semanticPath: "/portal/family/intake/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getIntakeSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[13]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-new-family-settings::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-new-family-settings",
      semanticPath: "/portal/family/intake/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[13]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-new-family-settings::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-new-family-settings",
      semanticPath: "/portal/family/intake/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[13]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "students-families-dashboard::DomainCore.listResources",
      moduleId: "students-families",
      routeId: "students-families-dashboard",
      semanticPath: "/admin/students/staff/dashboard",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listResources",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "listFamilies",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFamilies",
        rootField: "listFamilies",
        document:
          "query ListFamilies($input: AWSJSON) {\n  listFamilies(input: $input) {\n    items {\n      id\n      familyName\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "students-families-children::DomainCore.getResourceDetail",
      moduleId: "students-families",
      routeId: "students-families-children",
      semanticPath: "/admin/students/staff/family/:familyId/children",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.getResourceDetail",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getFamily",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFamily",
        rootField: "getFamily",
        document:
          "query GetFamily($familyId: String!) {\n  getFamily(familyId: $familyId) {\n    family {\n      id\n      familyName\n      address {\n        street\n        city\n        state\n        zipCode\n      }\n      homePhone\n      status\n      workflowStatus\n      synagogue\n      rabbi\n      hebrewFamilyName\n      maritalStatus\n      adoptedChild\n      stepParent\n      siblings {\n        name\n        age\n        school\n      }\n      grandparents {\n        paternal {\n          names\n          location\n          phone\n          family\n        }\n        maternal {\n          names\n          location\n          phone\n          family\n        }\n      }\n      paternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      maternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      updatedAt\n    }\n    students {\n      id\n      familyId\n      firstName\n      lastName\n      grade\n      status\n      updatedAt\n    }\n    parentContacts {\n      id\n      familyId\n      firstName\n      lastName\n      email\n      phone\n      relation\n      isPrimary\n      title\n      prefix\n      maidenName\n      occupation\n      firm\n      receivesComms\n      createdAt\n    }\n  }\n}",
        routeParamBindings: [
          {
            param: "familyId",
            variable: "familyId",
          },
        ],
        requiredVariables: ["familyId"],
      },
    },
    {
      id: "students-families-family::DomainCore.getResourceDetail",
      moduleId: "students-families",
      routeId: "students-families-family",
      semanticPath: "/admin/students/staff/family/:familyId/family",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.getResourceDetail",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getFamily",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFamily",
        rootField: "getFamily",
        document:
          "query GetFamily($familyId: String!) {\n  getFamily(familyId: $familyId) {\n    family {\n      id\n      familyName\n      address {\n        street\n        city\n        state\n        zipCode\n      }\n      homePhone\n      status\n      workflowStatus\n      synagogue\n      rabbi\n      hebrewFamilyName\n      maritalStatus\n      adoptedChild\n      stepParent\n      siblings {\n        name\n        age\n        school\n      }\n      grandparents {\n        paternal {\n          names\n          location\n          phone\n          family\n        }\n        maternal {\n          names\n          location\n          phone\n          family\n        }\n      }\n      paternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      maternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      updatedAt\n    }\n    students {\n      id\n      familyId\n      firstName\n      lastName\n      grade\n      status\n      updatedAt\n    }\n    parentContacts {\n      id\n      familyId\n      firstName\n      lastName\n      email\n      phone\n      relation\n      isPrimary\n      title\n      prefix\n      maidenName\n      occupation\n      firm\n      receivesComms\n      createdAt\n    }\n  }\n}",
        routeParamBindings: [
          {
            param: "familyId",
            variable: "familyId",
          },
        ],
        requiredVariables: ["familyId"],
      },
    },
    {
      id: "students-families-tuition::DomainCore.getResourceDetail",
      moduleId: "students-families",
      routeId: "students-families-tuition",
      semanticPath: "/admin/students/staff/family/:familyId/tuition",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.getResourceDetail",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getFamily",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFamily",
        rootField: "getFamily",
        document:
          "query GetFamily($familyId: String!) {\n  getFamily(familyId: $familyId) {\n    family {\n      id\n      familyName\n      address {\n        street\n        city\n        state\n        zipCode\n      }\n      homePhone\n      status\n      workflowStatus\n      synagogue\n      rabbi\n      hebrewFamilyName\n      maritalStatus\n      adoptedChild\n      stepParent\n      siblings {\n        name\n        age\n        school\n      }\n      grandparents {\n        paternal {\n          names\n          location\n          phone\n          family\n        }\n        maternal {\n          names\n          location\n          phone\n          family\n        }\n      }\n      paternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      maternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      updatedAt\n    }\n    students {\n      id\n      familyId\n      firstName\n      lastName\n      grade\n      status\n      updatedAt\n    }\n    parentContacts {\n      id\n      familyId\n      firstName\n      lastName\n      email\n      phone\n      relation\n      isPrimary\n      title\n      prefix\n      maidenName\n      occupation\n      firm\n      receivesComms\n      createdAt\n    }\n  }\n}",
        routeParamBindings: [
          {
            param: "familyId",
            variable: "familyId",
          },
        ],
        requiredVariables: ["familyId"],
      },
    },
    {
      id: "students-families-documents::DomainCore.listResourceDocuments",
      moduleId: "students-families",
      routeId: "students-families-documents",
      semanticPath: "/admin/students/staff/family/:familyId/documents",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listResourceDocuments",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "listFamilyDocuments",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFamilyDocuments",
        rootField: "listFamilyDocuments",
        document:
          "query ListFamilyDocuments($familyId: String!, $limit: Int, $nextToken: String) {\n  listFamilyDocuments(familyId: $familyId, limit: $limit, nextToken: $nextToken) {\n    items {\n      id\n      familyId\n      studentId\n      documentGroupId\n      fileName\n      status\n      uploadedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        routeParamBindings: [
          {
            param: "familyId",
            variable: "familyId",
          },
        ],
        requiredVariables: ["familyId"],
        defaultVariables: {
          limit: 25,
        },
      },
    },
    {
      id: "students-families-documents::DomainCore.uploadResourceDocument",
      moduleId: "students-families",
      routeId: "students-families-documents",
      semanticPath: "/admin/students/staff/family/:familyId/documents",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "DomainCore.uploadResourceDocument",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "requestFamilyDocumentUpload",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFamilyDocumentUpload",
        rootField: "requestFamilyDocumentUpload",
        document:
          "mutation RequestFamilyDocumentUpload($input: AWSJSON!) {\n  requestFamilyDocumentUpload(input: $input) {\n    uploadUrl\n    storageKey\n    resourceId\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "students-families-notes::DomainCore.listResourceNotes",
      moduleId: "students-families",
      routeId: "students-families-notes",
      semanticPath: "/admin/students/staff/family/:familyId/notes",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listResourceNotes",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "listFamilyTimelineEvents",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFamilyTimelineEvents",
        rootField: "listFamilyTimelineEvents",
        document:
          "query ListFamilyTimelineEvents($familyId: String!, $limit: Int, $nextToken: String) {\n  listFamilyTimelineEvents(familyId: $familyId, limit: $limit, nextToken: $nextToken) {\n    items {\n      id\n      familyId\n      studentId\n      eventType\n      title\n      content\n      createdAt\n      updatedAt\n    }\n    nextToken\n  }\n}",
        routeParamBindings: [
          {
            param: "familyId",
            variable: "familyId",
          },
        ],
        requiredVariables: ["familyId"],
        defaultVariables: {
          limit: 25,
        },
      },
    },
    {
      id: "students-families-notes::DomainCore.addResourceNote",
      moduleId: "students-families",
      routeId: "students-families-notes",
      semanticPath: "/admin/students/staff/family/:familyId/notes",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "DomainCore.addResourceNote",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createFamilyNote",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "CreateFamilyNote",
        rootField: "createFamilyNote",
        document:
          "mutation CreateFamilyNote($input: AWSJSON!) {\n  createFamilyNote(input: $input) {\n    id\n    familyId\n    studentId\n    eventType\n    title\n    content\n    createdAt\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-directory::Faculty.listFacultyDirectory",
      moduleId: "faculty",
      routeId: "faculty-directory",
      semanticPath: "/school/faculty",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "query",
      op: "Faculty.listFacultyDirectory",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "listFaculty",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFaculty",
        rootField: "listFaculty",
        document:
          "query ListFaculty($filter: AWSJSON) {\n  listFaculty(filter: $filter) {\n    items {\n      id\n      orgId\n      firstName\n      middleName\n      lastName\n      displayName\n      preferredName\n      hebrewFirstName\n      hebrewLastName\n      dateOfBirth\n      gender\n      profilePhotoUrl\n      personalEmail\n      email\n      phone\n      homePhone\n      address\n      employeeId\n      hireDate\n      position\n      employmentType\n      divisions\n      gradeLevels\n      subjectLabels\n      homeroom\n      reportsTo\n      tags\n      resourceId\n      primaryDivisionId\n      status\n      invitedAt\n      activatedAt\n      createdAt\n      updatedAt\n    }\n    nextToken\n  }\n}",
        defaultVariables: {
          filter: {},
        },
      },
    },
    {
      id: "faculty-directory::Faculty.createFaculty",
      moduleId: "faculty",
      routeId: "faculty-directory",
      semanticPath: "/school/faculty",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.createFaculty",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "createFaculty",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "CreateFaculty",
        rootField: "createFaculty",
        document:
          "mutation CreateFaculty($input: AWSJSON!) {\n  createFaculty(input: $input) {\n    id\n    orgId\n    status\n    firstName\n    lastName\n    displayName\n    middleName\n    preferredName\n    hebrewFirstName\n    hebrewLastName\n    dateOfBirth\n    gender\n    profilePhotoUrl\n    email\n    personalEmail\n    phone\n    homePhone\n    address\n    employeeId\n    hireDate\n    position\n    employmentType\n    divisions\n    gradeLevels\n    subjectLabels\n    homeroom\n    reportsTo\n    tags\n    userId\n    externalId\n    resourceId\n    primaryDivisionId\n    invitedAt\n    activatedAt\n    createdAt\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-directory::Faculty.updateFaculty",
      moduleId: "faculty",
      routeId: "faculty-directory",
      semanticPath: "/school/faculty",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.updateFaculty",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "updateFaculty",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateFaculty",
        rootField: "updateFaculty",
        document:
          "mutation UpdateFaculty($input: AWSJSON!) {\n  updateFaculty(input: $input) {\n    id\n    orgId\n    status\n    firstName\n    lastName\n    displayName\n    middleName\n    preferredName\n    hebrewFirstName\n    hebrewLastName\n    dateOfBirth\n    gender\n    profilePhotoUrl\n    email\n    personalEmail\n    phone\n    homePhone\n    address\n    employeeId\n    hireDate\n    position\n    employmentType\n    divisions\n    gradeLevels\n    subjectLabels\n    homeroom\n    reportsTo\n    tags\n    userId\n    externalId\n    resourceId\n    primaryDivisionId\n    invitedAt\n    activatedAt\n    createdAt\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-directory::Faculty.addAssignment",
      moduleId: "faculty",
      routeId: "faculty-directory",
      semanticPath: "/school/faculty",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.addAssignment",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "addFacultyAssignment",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AddFacultyAssignment",
        rootField: "addFacultyAssignment",
        document:
          "mutation AddFacultyAssignment($input: AWSJSON!) {\n  addFacultyAssignment(input: $input) {\n    assignmentType\n    divisionAssignment {\n      id\n      facultyId\n      divisionId\n      assignmentType\n      isPrimary\n      startAt\n      endAt\n      allowOverlap\n      createdAt\n      updatedAt\n    }\n    teachingAssignment {\n      id\n      facultyId\n      academicYear\n      termId\n      courseId\n      sectionId\n      role\n      divisionLabel\n      gradeLabel\n      subjectLabel\n      room\n      homeroom\n      studentCount\n      startAt\n      endAt\n      createdAt\n      updatedAt\n    }\n    schedule {\n      id\n      facultyId\n      academicYear\n      termId\n      template {\n        day\n        period\n        startMinute\n        endMinute\n        label\n        location\n        blockType\n        gradeLabel\n        subjectLabel\n        room\n      }\n      exceptions {\n        date\n        reason\n        cancelled\n        overrideBlocks {\n          day\n          period\n          startMinute\n          endMinute\n          label\n          location\n          blockType\n          gradeLabel\n          subjectLabel\n          room\n        }\n      }\n      createdAt\n      updatedAt\n    }\n    emergencyContact {\n      id\n      facultyId\n      name\n      relationship\n      phone\n      alternatePhone\n      email\n      priority\n      consentProvided\n      createdAt\n      updatedAt\n    }\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-directory::Faculty.exportFacultyDirectory",
      moduleId: "faculty",
      routeId: "faculty-directory",
      semanticPath: "/school/faculty",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.exportFacultyDirectory",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "exportFacultyDirectory",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "ExportFacultyDirectory",
        rootField: "exportFacultyDirectory",
        document:
          "mutation ExportFacultyDirectory($input: AWSJSON!) {\n  exportFacultyDirectory(input: $input) {\n    downloadUrl\n    fileName\n    contentType\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile::Faculty.getFacultyProfile",
      moduleId: "faculty",
      routeId: "faculty-profile",
      semanticPath: "/school/faculty/profile",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "query",
      op: "Faculty.getFacultyProfile",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "getFaculty",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFaculty",
        rootField: "getFaculty",
        document:
          "query GetFaculty($facultyId: String!) {\n  getFaculty(facultyId: $facultyId) {\n    id\n    orgId\n    firstName\n    middleName\n    lastName\n    displayName\n    preferredName\n    hebrewFirstName\n    hebrewLastName\n    dateOfBirth\n    gender\n    profilePhotoUrl\n    personalEmail\n    email\n    phone\n    homePhone\n    address\n    employeeId\n    hireDate\n    position\n    employmentType\n    divisions\n    gradeLevels\n    subjectLabels\n    homeroom\n    reportsTo\n    tags\n    resourceId\n    primaryDivisionId\n    status\n    invitedAt\n    activatedAt\n    createdAt\n    updatedAt\n  }\n}",
        routeParamBindings: [
          {
            param: "facultyId",
            variable: "facultyId",
          },
        ],
        requiredVariables: ["facultyId"],
      },
    },
    {
      id: "faculty-profile::Faculty.updateFaculty",
      moduleId: "faculty",
      routeId: "faculty-profile",
      semanticPath: "/school/faculty/profile",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.updateFaculty",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "updateFaculty",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateFaculty",
        rootField: "updateFaculty",
        document:
          "mutation UpdateFaculty($input: AWSJSON!) {\n  updateFaculty(input: $input) {\n    id\n    orgId\n    status\n    firstName\n    lastName\n    displayName\n    middleName\n    preferredName\n    hebrewFirstName\n    hebrewLastName\n    dateOfBirth\n    gender\n    profilePhotoUrl\n    email\n    personalEmail\n    phone\n    homePhone\n    address\n    employeeId\n    hireDate\n    position\n    employmentType\n    divisions\n    gradeLevels\n    subjectLabels\n    homeroom\n    reportsTo\n    tags\n    userId\n    externalId\n    resourceId\n    primaryDivisionId\n    invitedAt\n    activatedAt\n    createdAt\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile::Faculty.addAssignment",
      moduleId: "faculty",
      routeId: "faculty-profile",
      semanticPath: "/school/faculty/profile",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.addAssignment",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "addFacultyAssignment",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AddFacultyAssignment",
        rootField: "addFacultyAssignment",
        document:
          "mutation AddFacultyAssignment($input: AWSJSON!) {\n  addFacultyAssignment(input: $input) {\n    assignmentType\n    divisionAssignment {\n      id\n      facultyId\n      divisionId\n      assignmentType\n      isPrimary\n      startAt\n      endAt\n      allowOverlap\n      createdAt\n      updatedAt\n    }\n    teachingAssignment {\n      id\n      facultyId\n      academicYear\n      termId\n      courseId\n      sectionId\n      role\n      divisionLabel\n      gradeLabel\n      subjectLabel\n      room\n      homeroom\n      studentCount\n      startAt\n      endAt\n      createdAt\n      updatedAt\n    }\n    schedule {\n      id\n      facultyId\n      academicYear\n      termId\n      template {\n        day\n        period\n        startMinute\n        endMinute\n        label\n        location\n        blockType\n        gradeLabel\n        subjectLabel\n        room\n      }\n      exceptions {\n        date\n        reason\n        cancelled\n        overrideBlocks {\n          day\n          period\n          startMinute\n          endMinute\n          label\n          location\n          blockType\n          gradeLabel\n          subjectLabel\n          room\n        }\n      }\n      createdAt\n      updatedAt\n    }\n    emergencyContact {\n      id\n      facultyId\n      name\n      relationship\n      phone\n      alternatePhone\n      email\n      priority\n      consentProvided\n      createdAt\n      updatedAt\n    }\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile::Faculty.requestAssetUpload",
      moduleId: "faculty",
      routeId: "faculty-profile",
      semanticPath: "/school/faculty/profile",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.requestAssetUpload",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "requestFacultyAssetUpload",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFacultyAssetUpload",
        rootField: "requestFacultyAssetUpload",
        document:
          "mutation RequestFacultyAssetUpload($input: AWSJSON!) {\n  requestFacultyAssetUpload(input: $input) {\n    uploadUrl\n    storageKey\n    resourceId\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile-teaching::Faculty.listTeachingAssignments",
      moduleId: "faculty",
      routeId: "faculty-profile-teaching",
      semanticPath: "/school/faculty/profile/teaching",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "query",
      op: "Faculty.listTeachingAssignments",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "listFacultyAssignments",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFacultyAssignments",
        rootField: "listFacultyAssignments",
        document:
          "query ListFacultyAssignments($facultyId: String!, $type: String) {\n  listFacultyAssignments(facultyId: $facultyId, type: $type) {\n    items {\n      assignmentType\n      divisionAssignment {\n        id\n        facultyId\n        divisionId\n        assignmentType\n        isPrimary\n        startAt\n        endAt\n        allowOverlap\n        createdAt\n        updatedAt\n      }\n      teachingAssignment {\n        id\n        facultyId\n        academicYear\n        termId\n        courseId\n        sectionId\n        role\n        divisionLabel\n        gradeLabel\n        subjectLabel\n        room\n        homeroom\n        studentCount\n        startAt\n        endAt\n        createdAt\n        updatedAt\n      }\n      schedule {\n        id\n        facultyId\n        academicYear\n        termId\n        template {\n          day\n          period\n          startMinute\n          endMinute\n          label\n          location\n          blockType\n          gradeLabel\n          subjectLabel\n          room\n        }\n        exceptions {\n          date\n          reason\n          cancelled\n          overrideBlocks {\n            day\n            period\n            startMinute\n            endMinute\n            label\n            location\n            blockType\n            gradeLabel\n            subjectLabel\n            room\n          }\n        }\n        createdAt\n        updatedAt\n      }\n      emergencyContact {\n        id\n        facultyId\n        name\n        relationship\n        phone\n        alternatePhone\n        email\n        priority\n        consentProvided\n        createdAt\n        updatedAt\n      }\n    }\n    nextToken\n  }\n}",
        routeParamBindings: [
          {
            param: "facultyId",
            variable: "facultyId",
          },
        ],
        requiredVariables: ["facultyId"],
      },
    },
    {
      id: "faculty-profile-teaching::Faculty.addAssignment",
      moduleId: "faculty",
      routeId: "faculty-profile-teaching",
      semanticPath: "/school/faculty/profile/teaching",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.addAssignment",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "addFacultyAssignment",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AddFacultyAssignment",
        rootField: "addFacultyAssignment",
        document:
          "mutation AddFacultyAssignment($input: AWSJSON!) {\n  addFacultyAssignment(input: $input) {\n    assignmentType\n    divisionAssignment {\n      id\n      facultyId\n      divisionId\n      assignmentType\n      isPrimary\n      startAt\n      endAt\n      allowOverlap\n      createdAt\n      updatedAt\n    }\n    teachingAssignment {\n      id\n      facultyId\n      academicYear\n      termId\n      courseId\n      sectionId\n      role\n      divisionLabel\n      gradeLabel\n      subjectLabel\n      room\n      homeroom\n      studentCount\n      startAt\n      endAt\n      createdAt\n      updatedAt\n    }\n    schedule {\n      id\n      facultyId\n      academicYear\n      termId\n      template {\n        day\n        period\n        startMinute\n        endMinute\n        label\n        location\n        blockType\n        gradeLabel\n        subjectLabel\n        room\n      }\n      exceptions {\n        date\n        reason\n        cancelled\n        overrideBlocks {\n          day\n          period\n          startMinute\n          endMinute\n          label\n          location\n          blockType\n          gradeLabel\n          subjectLabel\n          room\n        }\n      }\n      createdAt\n      updatedAt\n    }\n    emergencyContact {\n      id\n      facultyId\n      name\n      relationship\n      phone\n      alternatePhone\n      email\n      priority\n      consentProvided\n      createdAt\n      updatedAt\n    }\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile-notes::Faculty.listNotes",
      moduleId: "faculty",
      routeId: "faculty-profile-notes",
      semanticPath: "/school/faculty/profile/notes",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "query",
      op: "Faculty.listNotes",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "listFacultyNotes",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFacultyNotes",
        rootField: "listFacultyNotes",
        document:
          "query ListFacultyNotes($facultyId: String!) {\n  listFacultyNotes(facultyId: $facultyId) {\n    items {\n      id\n      facultyId\n      authorId\n      authorLabel\n      visibility\n      body\n      category\n      isImportant\n      attachmentName\n      attachments {\n        resourceId\n        fileName\n        contentType\n        sizeBytes\n        storageKey\n        uploadedAt\n      }\n      createdAt\n      updatedAt\n    }\n    nextToken\n  }\n}",
        routeParamBindings: [
          {
            param: "facultyId",
            variable: "facultyId",
          },
        ],
        requiredVariables: ["facultyId"],
      },
    },
    {
      id: "faculty-profile-notes::Faculty.addNote",
      moduleId: "faculty",
      routeId: "faculty-profile-notes",
      semanticPath: "/school/faculty/profile/notes",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.addNote",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "addFacultyNote",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AddFacultyNote",
        rootField: "addFacultyNote",
        document:
          "mutation AddFacultyNote($input: AWSJSON!) {\n  addFacultyNote(input: $input) {\n    id\n    facultyId\n    authorId\n    authorLabel\n    body\n    visibility\n    category\n    isImportant\n    attachmentName\n    attachments {\n      resourceId\n      fileName\n      contentType\n      sizeBytes\n      storageKey\n      uploadedAt\n    }\n    createdAt\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile-notes::Faculty.requestAssetUpload",
      moduleId: "faculty",
      routeId: "faculty-profile-notes",
      semanticPath: "/school/faculty/profile/notes",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.requestAssetUpload",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "requestFacultyAssetUpload",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFacultyAssetUpload",
        rootField: "requestFacultyAssetUpload",
        document:
          "mutation RequestFacultyAssetUpload($input: AWSJSON!) {\n  requestFacultyAssetUpload(input: $input) {\n    uploadUrl\n    storageKey\n    resourceId\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile-communications::Faculty.listCommunications",
      moduleId: "faculty",
      routeId: "faculty-profile-communications",
      semanticPath: "/school/faculty/profile/communications",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "query",
      op: "Faculty.listCommunications",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "listFacultyCommunications",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFacultyCommunications",
        rootField: "listFacultyCommunications",
        document:
          "query ListFacultyCommunications($facultyId: String!) {\n  listFacultyCommunications(facultyId: $facultyId) {\n    items {\n      id\n      facultyId\n      channel\n      status\n      senderLabel\n      recipient\n      subject\n      body\n      attachments {\n        resourceId\n        fileName\n        contentType\n        sizeBytes\n        storageKey\n        uploadedAt\n      }\n      outboxId\n      providerMessageId\n      lastError\n      error\n      sentAt\n      createdAt\n      createdBy\n    }\n    nextToken\n  }\n}",
        routeParamBindings: [
          {
            param: "facultyId",
            variable: "facultyId",
          },
        ],
        requiredVariables: ["facultyId"],
      },
    },
    {
      id: "faculty-profile-communications::Faculty.sendCommunication",
      moduleId: "faculty",
      routeId: "faculty-profile-communications",
      semanticPath: "/school/faculty/profile/communications",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.sendCommunication",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "sendFacultyCommunication",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SendFacultyCommunication",
        rootField: "sendFacultyCommunication",
        document:
          "mutation SendFacultyCommunication($input: AWSJSON!) {\n  sendFacultyCommunication(input: $input) {\n    id\n    facultyId\n    channel\n    status\n    senderLabel\n    recipient\n    subject\n    body\n    attachments {\n      resourceId\n      fileName\n      contentType\n      sizeBytes\n      storageKey\n      uploadedAt\n    }\n    outboxId\n    providerMessageId\n    sentAt\n    lastError\n    error\n    createdAt\n    createdBy\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile-communications::Faculty.requestAssetUpload",
      moduleId: "faculty",
      routeId: "faculty-profile-communications",
      semanticPath: "/school/faculty/profile/communications",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.requestAssetUpload",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "requestFacultyAssetUpload",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFacultyAssetUpload",
        rootField: "requestFacultyAssetUpload",
        document:
          "mutation RequestFacultyAssetUpload($input: AWSJSON!) {\n  requestFacultyAssetUpload(input: $input) {\n    uploadUrl\n    storageKey\n    resourceId\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-dashboard::StudentsFamilies.getSchoolTuitionDashboardTree",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.getSchoolTuitionDashboardTree",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getSchoolTuitionDashboardTree",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "getSchoolTuitionDashboardTree",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-dashboard::StudentsFamilies.previewBulkChargeSegment",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.previewBulkChargeSegment",
      notes:
        "Explicit bulk-charge modal/action read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "previewBulkChargeSegment",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "previewBulkChargeSegment",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-dashboard::StudentsFamilies.getBulkChargeJob",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.getBulkChargeJob",
      notes:
        "Explicit bulk-charge job/status action read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getBulkChargeJob",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "getBulkChargeJob",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-dashboard::StudentsFamilies.getFamilyDocumentDownloadUrl",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.getFamilyDocumentDownloadUrl",
      notes:
        "Explicit artifact download action read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getFamilyDocumentDownloadUrl",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "getFamilyDocumentDownloadUrl",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-dashboard::StudentsFamilies.createFamilyBillingEntry",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.createFamilyBillingEntry",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createFamilyBillingEntry",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "createFamilyBillingEntry",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-dashboard::StudentsFamilies.createBulkCharge",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.createBulkCharge",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createBulkCharge",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "createBulkCharge",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-dashboard::StudentsFamilies.requestFamilyDocumentUpload",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.requestFamilyDocumentUpload",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "requestFamilyDocumentUpload",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFamilyDocumentUpload",
        rootField: "requestFamilyDocumentUpload",
        document:
          "mutation RequestFamilyDocumentUpload($input: AWSJSON!) {\n  requestFamilyDocumentUpload(input: $input) {\n    uploadUrl\n    storageKey\n    resourceId\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-dashboard::StudentsFamilies.createFamilyDocumentRecord",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.createFamilyDocumentRecord",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createFamilyDocumentRecord",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "createFamilyDocumentRecord",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.getSchoolTuitionFamilyLedgerTree",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.getSchoolTuitionFamilyLedgerTree",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getSchoolTuitionFamilyLedgerTree",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "getSchoolTuitionFamilyLedgerTree",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.listRecurringFeeDefinitions",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.listRecurringFeeDefinitions",
      notes:
        "Explicit recurring-fee management modal read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "listRecurringFeeDefinitions",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "listRecurringFeeDefinitions",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.listRecurringFeeAssignments",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.listRecurringFeeAssignments",
      notes:
        "Explicit recurring-fee management modal read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "listRecurringFeeAssignments",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "listRecurringFeeAssignments",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.getFamilyDocumentDownloadUrl",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.getFamilyDocumentDownloadUrl",
      notes:
        "Explicit artifact download action read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getFamilyDocumentDownloadUrl",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "getFamilyDocumentDownloadUrl",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.createFamilyBillingEntry",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.createFamilyBillingEntry",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createFamilyBillingEntry",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "createFamilyBillingEntry",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.createAdHocCharge",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.createAdHocCharge",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createAdHocCharge",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "createAdHocCharge",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.archiveAdHocTuitionCharge",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.archiveAdHocTuitionCharge",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "archiveAdHocTuitionCharge",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "archiveAdHocTuitionCharge",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.assignRecurringFee",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.assignRecurringFee",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "assignRecurringFee",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "assignRecurringFee",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.unassignRecurringFee",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.unassignRecurringFee",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "unassignRecurringFee",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "unassignRecurringFee",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.bulkAssignRecurringFee",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.bulkAssignRecurringFee",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "bulkAssignRecurringFee",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "bulkAssignRecurringFee",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.reverseTuitionPayment",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.reverseTuitionPayment",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "reverseTuitionPayment",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "reverseTuitionPayment",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.issueTuitionRefund",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.issueTuitionRefund",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "issueTuitionRefund",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "issueTuitionRefund",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "school-run-reports::AssistantPlatform.getAssistantReportGenerationWorkspace",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "query",
      op: "AssistantPlatform.getAssistantReportGenerationWorkspace",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "getAssistantReportGenerationWorkspace",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "getAssistantReportGenerationWorkspace",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "school-run-reports::AssistantPlatform.getAssistantSessionState",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "query",
      op: "AssistantPlatform.getAssistantSessionState",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "getAssistantSessionState",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "getAssistantSessionState",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "school-run-reports::AssistantPlatform.listAssistantWorkItems",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "query",
      op: "AssistantPlatform.listAssistantWorkItems",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "listAssistantWorkItems",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "listAssistantWorkItems",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
    {
      id: "school-run-reports::AssistantPlatform.mutateAssistantRun",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "mutation",
      op: "AssistantPlatform.mutateAssistantRun",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "mutateAssistantRun",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "mutateAssistantRun",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "school-run-reports::AssistantPlatform.mutateAssistantReportTemplate",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "mutation",
      op: "AssistantPlatform.mutateAssistantReportTemplate",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "mutateAssistantReportTemplate",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "mutateAssistantReportTemplate",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "school-run-reports::AssistantPlatform.mutateAssistantReportSchedule",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "mutation",
      op: "AssistantPlatform.mutateAssistantReportSchedule",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "mutateAssistantReportSchedule",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "mutateAssistantReportSchedule",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ]);

export const ystnjSemanticOperationManifestByRuntimeOperationId: Readonly<
  Record<string, readonly YstnjSemanticOperationManifestEntry[]>
> = Object.freeze({
  listApplications: [
    {
      id: "admissions-dashboard::Admissions.listApplications",
      moduleId: "admissions",
      routeId: "admissions-dashboard",
      semanticPath: "/admin/admissions/staff/dashboard",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.listApplications",
      notes: "List projection with filter/sort/pagination semantics.",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions runtime access is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "listApplications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "listApplications",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {
          limit: 25,
        },
      },
    },
  ],
  listNotifications: [
    {
      id: "admissions-dashboard::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-dashboard",
      semanticPath: "/admin/admissions/staff/dashboard",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions runtime access is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "admissions-applicant-detail::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "admissions-applicant-children::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-applicant-children",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/children",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant children is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "admissions-applicant-tuition::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "admissions-applicant-documents::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-applicant-documents",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/documents",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant documents is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "admissions-applicant-notes::DomainCore.listNotifications",
      moduleId: "admissions",
      routeId: "admissions-applicant-notes",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/notes",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant notes is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-dashboard::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-dashboard",
      semanticPath: "/admin/financial-aid/staff/dashboard",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid dashboard is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::DomainCore.listNotifications",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "settings-general::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "control-plane-integrations::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "settings-assistant-workflow::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "settings-users::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "settings-admissions::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "settings-admissions",
      semanticPath: "/admin/settings/staff/admissions",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "settings-financial-aid::DomainCore.listNotifications",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-dashboard::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-dashboard",
      semanticPath: "/portal/family/dashboard",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent dashboard route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-shell::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-shell",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-applications::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-applications",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent tuition route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-enrollment::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-enrollment",
      semanticPath: "/portal/family/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-financial-aid::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-financial-aid",
      semanticPath: "/portal/family/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-settings::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-settings",
      semanticPath: "/portal/family/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-calendar::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-calendar",
      semanticPath: "/portal/family/calendar",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent calendar route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-attendance::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-attendance",
      semanticPath: "/portal/family/attendance",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent attendance route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-academic::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-academic",
      semanticPath: "/portal/family/academic",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent academic route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-family-resources::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-family-resources",
      semanticPath: "/portal/family/resources",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent resources route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-new-family-applications::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-new-family-applications",
      semanticPath: "/portal/family/intake/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake applications route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[10]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-new-family-enrollment::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-new-family-enrollment",
      semanticPath: "/portal/family/intake/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[11]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-new-family-financial-aid::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-new-family-financial-aid",
      semanticPath: "/portal/family/intake/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[12]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
    {
      id: "portal-new-family-settings::DomainCore.listNotifications",
      moduleId: "parent-portal",
      routeId: "portal-new-family-settings",
      semanticPath: "/portal/family/intake/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "DomainCore.listNotifications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[13]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotifications",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotifications",
        rootField: "listNotifications",
        document:
          "query ListNotifications($input: AWSJSON) {\n  listNotifications(input: $input) {\n    items {\n      id\n      title\n      deliveryState\n      module\n      route\n      createdAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {
            includeRead: true,
            limit: 50,
          },
        },
      },
    },
  ],
  markNotificationRead: [
    {
      id: "admissions-dashboard::DomainCore.markNotificationRead",
      moduleId: "admissions",
      routeId: "admissions-dashboard",
      semanticPath: "/admin/admissions/staff/dashboard",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions runtime access is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-detail::DomainCore.markNotificationRead",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-dashboard::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-dashboard",
      semanticPath: "/admin/financial-aid/staff/dashboard",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid dashboard is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::DomainCore.markNotificationRead",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-dashboard::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-dashboard",
      semanticPath: "/portal/family/dashboard",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent dashboard route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-applications::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-applications",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent tuition route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-enrollment::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-enrollment",
      semanticPath: "/portal/family/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-financial-aid::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-financial-aid",
      semanticPath: "/portal/family/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-settings::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-settings",
      semanticPath: "/portal/family/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-calendar::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-calendar",
      semanticPath: "/portal/family/calendar",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent calendar route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-attendance::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-attendance",
      semanticPath: "/portal/family/attendance",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent attendance route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-academic::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-academic",
      semanticPath: "/portal/family/academic",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent academic route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-family-resources::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-family-resources",
      semanticPath: "/portal/family/resources",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent resources route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-new-family-applications::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-new-family-applications",
      semanticPath: "/portal/family/intake/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake applications route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[10]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-new-family-enrollment::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-new-family-enrollment",
      semanticPath: "/portal/family/intake/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[11]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-new-family-financial-aid::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-new-family-financial-aid",
      semanticPath: "/portal/family/intake/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[12]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "portal-new-family-settings::DomainCore.markNotificationRead",
      moduleId: "parent-portal",
      routeId: "portal-new-family-settings",
      semanticPath: "/portal/family/intake/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markNotificationRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[13]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markNotificationRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkNotificationRead",
        rootField: "markNotificationRead",
        document:
          "mutation MarkNotificationRead($input: AWSJSON!) {\n  markNotificationRead(input: $input) {\n    id\n    deliveryState\n    readAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  getApplication: [
    {
      id: "admissions-applicant-detail::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-children::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-children",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/children",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant children is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-family::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-family",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/family",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant family is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-tuition::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-documents::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-documents",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/documents",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant documents is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
    {
      id: "admissions-applicant-notes::Admissions.getApplicationDetail",
      moduleId: "admissions",
      routeId: "admissions-applicant-notes",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/notes",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant notes is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getApplication",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "id",
          },
        ],
        requiredVariables: ["id"],
      },
    },
  ],
  addNote: [
    {
      id: "admissions-applicant-detail::Admissions.addInternalNote",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "addNote",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "addNote",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-notes::Admissions.addInternalNote",
      moduleId: "admissions",
      routeId: "admissions-applicant-notes",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/notes",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant notes is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "addNote",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "addNote",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  addDocument: [
    {
      id: "admissions-applicant-detail::Admissions.attachDocument",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.attachDocument",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "addDocument",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "addDocument",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "admissions-applicant-documents::Admissions.attachDocument",
      moduleId: "admissions",
      routeId: "admissions-applicant-documents",
      semanticPath: "/admin/admissions/staff/applicant/:familyId/documents",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.attachDocument",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant documents is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "addDocument",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "addDocument",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  getNotification: [
    {
      id: "admissions-applicant-detail::DomainCore.getNotification",
      moduleId: "admissions",
      routeId: "admissions-applicant-detail",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant detail is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::DomainCore.getNotification",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "DomainCore.getNotification",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "getNotification",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetNotification",
        rootField: "getNotification",
        document:
          "query GetNotification($id: String!, $input: AWSJSON) {\n  getNotification(id: $id, input: $input) {\n    id\n    title\n    deliveryState\n    module\n    route\n    readAt\n  }\n}",
        requiredVariables: ["id"],
      },
    },
  ],
  getAdmissionsTuitionConfiguration: [
    {
      id: "admissions-applicant-tuition::Admissions.getAdmissionsTuitionConfiguration",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "query",
      op: "Admissions.getAdmissionsTuitionConfiguration",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "getAdmissionsTuitionConfiguration",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsQuery",
        document:
          "query AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsQuery",
          operationId: "getAdmissionsTuitionConfiguration",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
  ],
  upsertAdmissionsTuitionConfiguration: [
    {
      id: "admissions-applicant-tuition::Admissions.upsertAdmissionsTuitionConfiguration",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.upsertAdmissionsTuitionConfiguration",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "upsertAdmissionsTuitionConfiguration",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "upsertAdmissionsTuitionConfiguration",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  generateTuitionContract: [
    {
      id: "admissions-applicant-tuition::Admissions.generateTuitionContract",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.generateTuitionContract",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "generateTuitionContract",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "generateTuitionContract",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  sendTuitionContract: [
    {
      id: "admissions-applicant-tuition::Admissions.sendTuitionContract",
      moduleId: "admissions",
      routeId: "admissions-applicant-tuition",
      semanticPath: "/admin/admissions/staff/applicant/:applicationId/tuition",
      persona: "staff",
      boundedContext: "Admissions",
      aggregateRoot: "Application",
      kind: "mutation",
      op: "Admissions.sendTuitionContract",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions applicant tuition is reviewer-scoped by Cognito group and must prove with the admissions reviewer auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/admissions.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/yst-admissions-local",
      },
      runtime: {
        routerName: "domainAdmissionsApi",
        operationId: "sendTuitionContract",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AdmissionsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AdmissionsTransport",
        rootField: "domainAdmissionsMutation",
        document:
          "mutation AdmissionsTransport($operationId: String!, $input: AWSJSON) {\n  domainAdmissionsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainAdmissionsMutation",
          operationId: "sendTuitionContract",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  listFinancialAidApplicationsForReview: [
    {
      id: "fa-staff-dashboard::FinancialAid.listApplications",
      moduleId: "financial-aid",
      routeId: "fa-staff-dashboard",
      semanticPath: "/admin/financial-aid/staff/dashboard",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.listApplications",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid dashboard is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "listFinancialAidApplicationsForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "listFinancialAidApplicationsForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  assignFinancialAidApplication: [
    {
      id: "fa-staff-dashboard::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-dashboard",
      semanticPath: "/admin/financial-aid/staff/dashboard",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid dashboard is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.assignApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.assignApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "assignFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "assignFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  getFinancialAidDocumentStatus: [
    {
      id: "fa-staff-help::FinancialAid.getFinancialAidDocumentStatus",
      moduleId: "financial-aid",
      routeId: "fa-staff-help",
      semanticPath: "/admin/financial-aid/staff/help",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getFinancialAidDocumentStatus",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid help is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidDocumentStatus",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidDocumentStatus",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
  ],
  uploadFinancialAidDocument: [
    {
      id: "fa-staff-help::FinancialAid.uploadFinancialAidDocument",
      moduleId: "financial-aid",
      routeId: "fa-staff-help",
      semanticPath: "/admin/financial-aid/staff/help",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.uploadFinancialAidDocument",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid help is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "uploadFinancialAidDocument",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "uploadFinancialAidDocument",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  getFinancialAidApplicationForReview: [
    {
      id: "fa-staff-applicant-detail::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.getApplicationDetail",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getApplicationDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidApplicationForReview",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidApplicationForReview",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
  ],
  getFinancialAidStatusHistory: [
    {
      id: "fa-staff-applicant-detail::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.getStatusHistory",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "query",
      op: "FinancialAid.getStatusHistory",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidStatusHistory",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidStatusHistory",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
  ],
  makeFinancialAidDecision: [
    {
      id: "fa-staff-applicant-detail::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.makeDecision",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.makeDecision",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "makeFinancialAidDecision",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "makeFinancialAidDecision",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  updateFinancialAidApplication: [
    {
      id: "fa-staff-applicant-detail::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.addInternalNote",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.addInternalNote",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.updateApplication",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.updateApplication",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "updateFinancialAidApplication",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "updateFinancialAidApplication",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  requestFinancialAidMoreInfo: [
    {
      id: "fa-staff-applicant-detail::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.requestDocuments",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.requestDocuments",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "requestFinancialAidMoreInfo",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "requestFinancialAidMoreInfo",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  generateFinancialAidDecisionLetter: [
    {
      id: "fa-staff-applicant-detail::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-family-profile::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-family-profile",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/family-profile",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-income-calculation::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-income-calculation",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/income-calculation",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-assets-equity::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-assets-equity",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/assets-equity",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-expenses-spending::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-expenses-spending",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/expenses-spending",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-contract-flags::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-contract-flags",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/contract-flags",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-documents::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-documents",
      semanticPath:
        "/admin/financial-aid/staff/applicant/:applicationId/documents",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "fa-staff-applicant-detail-notes::FinancialAid.generateDecisionLetter",
      moduleId: "financial-aid",
      routeId: "fa-staff-applicant-detail-notes",
      semanticPath: "/admin/financial-aid/staff/applicant/:applicationId/notes",
      persona: "staff",
      boundedContext: "FinancialAid",
      aggregateRoot: "FinancialAidApplication",
      kind: "mutation",
      op: "FinancialAid.generateDecisionLetter",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial aid applicant detail is a staff-readable school route and must prove with the staff auth lane.",
      routeParamKeys: ["applicationId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/financial-aid.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/financial-aid-local",
        domainContractRef:
          "artifacts/external-ui-scan/financial-aid-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "generateFinancialAidDecisionLetter",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidMutation",
        document:
          "mutation FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidMutation",
          operationId: "generateFinancialAidDecisionLetter",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  getPayrollDashboard: [
    {
      id: "payroll-dashboard::Payroll.getDashboard",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "query",
      op: "Payroll.getDashboard",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "getPayrollDashboard",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "PayrollTransport",
        rootField: "domainPayrollQuery",
        document:
          "query PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollQuery",
          operationId: "getPayrollDashboard",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  switchPayrollPeriod: [
    {
      id: "payroll-dashboard::Payroll.switchPeriod",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.switchPeriod",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "switchPayrollPeriod",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "switchPayrollPeriod",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  submitPayrollPeriodForApproval: [
    {
      id: "payroll-dashboard::Payroll.submitForApproval",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.submitForApproval",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "submitPayrollPeriodForApproval",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "submitPayrollPeriodForApproval",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  approvePayrollPeriod: [
    {
      id: "payroll-dashboard::Payroll.approvePeriod",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.approvePeriod",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "approvePayrollPeriod",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "approvePayrollPeriod",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  rejectPayrollPeriod: [
    {
      id: "payroll-dashboard::Payroll.rejectPeriod",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.rejectPeriod",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "rejectPayrollPeriod",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "rejectPayrollPeriod",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  unlockPayrollPeriod: [
    {
      id: "payroll-dashboard::Payroll.unlockPeriod",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.unlockPeriod",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "unlockPayrollPeriod",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "unlockPayrollPeriod",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  exportPayrollPeriod: [
    {
      id: "payroll-dashboard::Payroll.exportPeriod",
      moduleId: "payroll",
      routeId: "payroll-dashboard",
      semanticPath: "/admin/payroll/dashboard",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "PayPeriod",
      kind: "mutation",
      op: "Payroll.exportPeriod",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll dashboard is admin-governed and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "exportPayrollPeriod",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "exportPayrollPeriod",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  getPayrollEmployeeDetail: [
    {
      id: "payroll-employee-detail::Payroll.getEmployeeDetail",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "query",
      op: "Payroll.getEmployeeDetail",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "getPayrollEmployeeDetail",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "PayrollTransport",
        rootField: "domainPayrollQuery",
        document:
          "query PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollQuery",
          operationId: "getPayrollEmployeeDetail",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  listPayrollAuditLog: [
    {
      id: "payroll-employee-detail::Payroll.listAuditLog",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "query",
      op: "Payroll.listAuditLog",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "listPayrollAuditLog",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "PayrollTransport",
        rootField: "domainPayrollQuery",
        document:
          "query PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollQuery",
          operationId: "listPayrollAuditLog",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  upsertPayrollEmployeeProfile: [
    {
      id: "payroll-employee-detail::Payroll.updateEmployeeProfile",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateEmployeeProfile",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollEmployeeProfile",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollEmployeeProfile",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  upsertPayrollPosition: [
    {
      id: "payroll-employee-detail::Payroll.updatePosition",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updatePosition",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollPosition",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollPosition",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  upsertPayrollStipend: [
    {
      id: "payroll-employee-detail::Payroll.updateStipend",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateStipend",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollStipend",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollStipend",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  upsertPayrollTimeEntry: [
    {
      id: "payroll-employee-detail::Payroll.updateTimeEntry",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateTimeEntry",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollTimeEntry",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollTimeEntry",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  upsertPayrollAdjustment: [
    {
      id: "payroll-employee-detail::Payroll.updateAdjustment",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateAdjustment",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollAdjustment",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollAdjustment",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  upsertPayrollExternalTuitionPayment: [
    {
      id: "payroll-employee-detail::Payroll.updateExternalTuitionPayment",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateExternalTuitionPayment",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollExternalTuitionPayment",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollExternalTuitionPayment",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  upsertPayrollDeductionEntry: [
    {
      id: "payroll-employee-detail::Payroll.updateDeductionEntry",
      moduleId: "payroll",
      routeId: "payroll-employee-detail",
      semanticPath: "/admin/payroll/employee/:employeeId",
      persona: "administrator",
      boundedContext: "Payroll",
      aggregateRoot: "Employee",
      kind: "mutation",
      op: "Payroll.updateDeductionEntry",
      runtimeBindingRequired: true,
      verificationReason:
        "Payroll employee detail route proof must use the admin auth lane.",
      routeParamKeys: ["employeeId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/payroll.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/school-payroll-local",
        domainContractRef:
          "artifacts/external-ui-scan/school-payroll-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPayrollApi",
        operationId: "upsertPayrollDeductionEntry",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "PayrollDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PayrollTransport",
        rootField: "domainPayrollMutation",
        document:
          "mutation PayrollTransport($operationId: String!, $input: AWSJSON) {\n  domainPayrollMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPayrollMutation",
          operationId: "upsertPayrollDeductionEntry",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  getModuleConfig: [
    {
      id: "settings-general::StaffSettings.getGeneralSettings",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.getGeneralSettings",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "getModuleConfig",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetModuleConfig",
        rootField: "getModuleConfig",
        document:
          "query GetModuleConfig($orgId: String, $moduleKey: String!) {\n  getModuleConfig(orgId: $orgId, moduleKey: $moduleKey) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        defaultVariables: {
          moduleKey: "settings.general",
        },
        requiredVariables: ["moduleKey"],
      },
    },
    {
      id: "settings-admissions::StaffSettings.getAdmissionsSettings",
      moduleId: "settings",
      routeId: "settings-admissions",
      semanticPath: "/admin/settings/staff/admissions",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.getAdmissionsSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "getModuleConfig",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetModuleConfig",
        rootField: "getModuleConfig",
        document:
          "query GetModuleConfig($orgId: String, $moduleKey: String!) {\n  getModuleConfig(orgId: $orgId, moduleKey: $moduleKey) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        defaultVariables: {
          moduleKey: "settings.admissions",
        },
        requiredVariables: ["moduleKey"],
      },
    },
    {
      id: "settings-financial-aid::StaffSettings.getFinancialAidSettings",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.getFinancialAidSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "getModuleConfig",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetModuleConfig",
        rootField: "getModuleConfig",
        document:
          "query GetModuleConfig($orgId: String, $moduleKey: String!) {\n  getModuleConfig(orgId: $orgId, moduleKey: $moduleKey) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        defaultVariables: {
          moduleKey: "staff_settings",
        },
        requiredVariables: ["moduleKey"],
      },
    },
  ],
  updateModuleConfig: [
    {
      id: "settings-general::StaffSettings.updateGeneralSettings",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.updateGeneralSettings",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "updateModuleConfig",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateModuleConfig",
        rootField: "updateModuleConfig",
        document:
          "mutation UpdateModuleConfig($input: AWSJSON!) {\n  updateModuleConfig(input: $input) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-admissions::StaffSettings.updateAdmissionsSettings",
      moduleId: "settings",
      routeId: "settings-admissions",
      semanticPath: "/admin/settings/staff/admissions",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.updateAdmissionsSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "updateModuleConfig",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateModuleConfig",
        rootField: "updateModuleConfig",
        document:
          "mutation UpdateModuleConfig($input: AWSJSON!) {\n  updateModuleConfig(input: $input) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-financial-aid::StaffSettings.updateFinancialAidSettings",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.updateFinancialAidSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "updateModuleConfig",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateModuleConfig",
        rootField: "updateModuleConfig",
        document:
          "mutation UpdateModuleConfig($input: AWSJSON!) {\n  updateModuleConfig(input: $input) {\n    orgId\n    moduleKey\n    version\n    payload\n    updatedAt\n    updatedBy\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  listModuleEnablementAuditEvents: [
    {
      id: "settings-general::StaffSettings.listModuleEnablementAuditEvents",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.listModuleEnablementAuditEvents",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "listModuleEnablementAuditEvents",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "SettingsTransport",
        rootField: "domainSettingsQuery",
        document:
          "query SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsQuery",
          operationId: "listModuleEnablementAuditEvents",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {
          limit: 5,
        },
      },
    },
  ],
  listNotificationPreferences: [
    {
      id: "settings-general::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "control-plane-integrations::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "settings-assistant-workflow::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "settings-users::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "settings-admissions::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-admissions",
      semanticPath: "/admin/settings/staff/admissions",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "settings-financial-aid::DomainCore.listNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "DomainCore.listNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-settings::ParentPortal.getSettings",
      moduleId: "parent-portal",
      routeId: "portal-family-settings",
      semanticPath: "/portal/family/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-new-family-settings::ParentPortal.getIntakeSettings",
      moduleId: "parent-portal",
      routeId: "portal-new-family-settings",
      semanticPath: "/portal/family/intake/settings",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getIntakeSettings",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake settings route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[13]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "listNotificationPreferences",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListNotificationPreferences",
        rootField: "listNotificationPreferences",
        document:
          "query ListNotificationPreferences($input: AWSJSON) {\n  listNotificationPreferences(input: $input) {\n    items {\n      actorId\n      role\n      moduleFilters\n      categoryFilters\n      muted\n      digestFrequency\n      updatedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
  ],
  updateNotificationPreferences: [
    {
      id: "settings-general::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-general",
      semanticPath: "/admin/settings/staff/general",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "control-plane-integrations::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-assistant-workflow::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-users::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-admissions::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-admissions",
      semanticPath: "/admin/settings/staff/admissions",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Admissions settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "settings-financial-aid::DomainCore.updateNotificationPreferences",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "DomainCore.updateNotificationPreferences",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "updateNotificationPreferences",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateNotificationPreferences",
        rootField: "updateNotificationPreferences",
        document:
          "mutation UpdateNotificationPreferences($input: AWSJSON!) {\n  updateNotificationPreferences(input: $input) {\n    actorId\n    role\n    moduleFilters\n    categoryFilters\n    muted\n    digestFrequency\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  getAssistantSpreadsheetBridgeStatus: [
    {
      id: "control-plane-integrations::StaffSettings.getIntegrationsStatus",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "StaffSettings.getIntegrationsStatus",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantIntegrationsApi",
        operationId: "getAssistantSpreadsheetBridgeStatus",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantIntegrationsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantIntegrationsTransport",
        rootField: "assistantIntegrationsQuery",
        document:
          "query AssistantIntegrationsTransport($operationId: String!, $input: AWSJSON) {\n  assistantIntegrationsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantIntegrationsQuery",
          operationId: "getAssistantSpreadsheetBridgeStatus",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  getPaymentControlPlaneReadiness: [
    {
      id: "control-plane-integrations::Payments.getControlPlaneReadiness",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "Payments.getControlPlaneReadiness",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPaymentsApi",
        operationId: "getPaymentControlPlaneReadiness",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "PaymentsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "PaymentsTransport",
        rootField: "domainPaymentsQuery",
        document:
          "query PaymentsTransport($operationId: String!, $input: AWSJSON) {\n  domainPaymentsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPaymentsQuery",
          operationId: "getPaymentControlPlaneReadiness",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  startStripeConnectedAccountOnboarding: [
    {
      id: "control-plane-integrations::Payments.startConnectedAccountOnboarding",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "Payments.startConnectedAccountOnboarding",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPaymentsApi",
        operationId: "startStripeConnectedAccountOnboarding",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "PaymentsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PaymentsTransport",
        rootField: "domainPaymentsMutation",
        document:
          "mutation PaymentsTransport($operationId: String!, $input: AWSJSON) {\n  domainPaymentsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPaymentsMutation",
          operationId: "startStripeConnectedAccountOnboarding",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  completeStripeConnectedAccountOnboarding: [
    {
      id: "control-plane-integrations::Payments.completeConnectedAccountOnboarding",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "Payments.completeConnectedAccountOnboarding",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPaymentsApi",
        operationId: "completeStripeConnectedAccountOnboarding",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "PaymentsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PaymentsTransport",
        rootField: "domainPaymentsMutation",
        document:
          "mutation PaymentsTransport($operationId: String!, $input: AWSJSON) {\n  domainPaymentsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPaymentsMutation",
          operationId: "completeStripeConnectedAccountOnboarding",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  updatePaymentControlPlane: [
    {
      id: "control-plane-integrations::Payments.updateControlPlane",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "Payments.updateControlPlane",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainPaymentsApi",
        operationId: "updatePaymentControlPlane",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "PaymentsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "PaymentsTransport",
        rootField: "domainPaymentsMutation",
        document:
          "mutation PaymentsTransport($operationId: String!, $input: AWSJSON) {\n  domainPaymentsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainPaymentsMutation",
          operationId: "updatePaymentControlPlane",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  startAssistantSpreadsheetBridgeAuth: [
    {
      id: "control-plane-integrations::StaffSettings.startGoogleSheetsOauthBridge",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "StaffSettings.startGoogleSheetsOauthBridge",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantIntegrationsApi",
        operationId: "startAssistantSpreadsheetBridgeAuth",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantIntegrationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantIntegrationsTransport",
        rootField: "assistantIntegrationsMutation",
        document:
          "mutation AssistantIntegrationsTransport($operationId: String!, $input: AWSJSON) {\n  assistantIntegrationsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantIntegrationsMutation",
          operationId: "startAssistantSpreadsheetBridgeAuth",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["redirectUri"],
      },
    },
  ],
  completeAssistantSpreadsheetBridgeAuth: [
    {
      id: "control-plane-integrations::StaffSettings.finalizeGoogleSheetsOauthBridge",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "StaffSettings.finalizeGoogleSheetsOauthBridge",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantIntegrationsApi",
        operationId: "completeAssistantSpreadsheetBridgeAuth",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantIntegrationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantIntegrationsTransport",
        rootField: "assistantIntegrationsMutation",
        document:
          "mutation AssistantIntegrationsTransport($operationId: String!, $input: AWSJSON) {\n  assistantIntegrationsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantIntegrationsMutation",
          operationId: "completeAssistantSpreadsheetBridgeAuth",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["code", "state"],
      },
    },
  ],
  exportAssistantSpreadsheetToGoogleDrive: [
    {
      id: "control-plane-integrations::StaffSettings.exportAssistantSpreadsheetToDrive",
      moduleId: "settings",
      routeId: "control-plane-integrations",
      semanticPath: "/admin/control-plane/integrations",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "StaffSettings.exportAssistantSpreadsheetToDrive",
      runtimeBindingRequired: true,
      verificationReason:
        "canonical super-administrator integrations control-plane route with assistant bridge, payments, and notifications runtime bindings",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantIntegrationsApi",
        operationId: "exportAssistantSpreadsheetToGoogleDrive",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantIntegrationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantIntegrationsTransport",
        rootField: "assistantIntegrationsMutation",
        document:
          "mutation AssistantIntegrationsTransport($operationId: String!, $input: AWSJSON) {\n  assistantIntegrationsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantIntegrationsMutation",
          operationId: "exportAssistantSpreadsheetToGoogleDrive",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["fileName"],
      },
    },
  ],
  listAssistantWorkflowTemplates: [
    {
      id: "settings-assistant-workflow::AssistantPlatform.listAssistantWorkflowTemplates",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "AssistantPlatform.listAssistantWorkflowTemplates",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "listAssistantWorkflowTemplates",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "listAssistantWorkflowTemplates",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  getAssistantWorkflow: [
    {
      id: "settings-assistant-workflow::AssistantPlatform.getAssistantWorkflow",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "AssistantPlatform.getAssistantWorkflow",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "getAssistantWorkflow",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "getAssistantWorkflow",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  listAssistantWorkflowExecutions: [
    {
      id: "settings-assistant-workflow::AssistantPlatform.listAssistantWorkflowExecutions",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "AssistantPlatform.listAssistantWorkflowExecutions",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "listAssistantWorkflowExecutions",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "listAssistantWorkflowExecutions",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  upsertAssistantWorkflowDraft: [
    {
      id: "settings-assistant-workflow::AssistantPlatform.upsertAssistantWorkflowDraft",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "AssistantPlatform.upsertAssistantWorkflowDraft",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "upsertAssistantWorkflowDraft",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "upsertAssistantWorkflowDraft",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  submitAssistantWorkflowForApproval: [
    {
      id: "settings-assistant-workflow::AssistantPlatform.submitAssistantWorkflowForApproval",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "AssistantPlatform.submitAssistantWorkflowForApproval",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "submitAssistantWorkflowForApproval",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "submitAssistantWorkflowForApproval",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  reviewAssistantWorkflow: [
    {
      id: "settings-assistant-workflow::AssistantPlatform.reviewAssistantWorkflow",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "AssistantPlatform.reviewAssistantWorkflow",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "reviewAssistantWorkflow",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "reviewAssistantWorkflow",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  mutateAssistantRun: [
    {
      id: "settings-assistant-workflow::AssistantPlatform.mutateAssistantRun",
      moduleId: "settings",
      routeId: "settings-assistant-workflow",
      semanticPath: "/admin/control-plane/assistant-workflows/:workflowId",
      persona: "super-administrator",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "AssistantPlatform.mutateAssistantRun",
      runtimeBindingRequired: true,
      verificationReason:
        "super-administrator workflow studio depends on assistant platform workflow draft, moderation, and execution bindings",
      routeParamKeys: ["workflowId"],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "mutateAssistantRun",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "mutateAssistantRun",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "school-run-reports::AssistantPlatform.mutateAssistantRun",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "mutation",
      op: "AssistantPlatform.mutateAssistantRun",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "mutateAssistantRun",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "mutateAssistantRun",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  listStaffUsers: [
    {
      id: "settings-users::StaffSettings.listUsers",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.listUsers",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "listStaffUsers",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "SettingsTransport",
        rootField: "domainSettingsQuery",
        document:
          "query SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsQuery",
          operationId: "listStaffUsers",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  updateStaffUserRole: [
    {
      id: "settings-users::StaffSettings.updateUserRoles",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.updateUserRoles",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "updateStaffUserRole",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "updateStaffUserRole",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  inviteStaffUser: [
    {
      id: "settings-users::StaffSettings.inviteUser",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.inviteUser",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "inviteStaffUser",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "inviteStaffUser",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  resendStaffInvite: [
    {
      id: "settings-users::StaffSettings.resendInvite",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.resendInvite",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "resendStaffInvite",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "resendStaffInvite",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  deactivateStaffUser: [
    {
      id: "settings-users::StaffSettings.suspendUser",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.suspendUser",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "deactivateStaffUser",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "deactivateStaffUser",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  reactivateStaffUser: [
    {
      id: "settings-users::StaffSettings.reactivateUser",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.reactivateUser",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "reactivateStaffUser",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "reactivateStaffUser",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  listStaffCodes: [
    {
      id: "settings-users::StaffSettings.listStaffCodes",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.listStaffCodes",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "listStaffCodes",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "SettingsTransport",
        rootField: "domainSettingsQuery",
        document:
          "query SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsQuery",
          operationId: "listStaffCodes",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  createStaffCode: [
    {
      id: "settings-users::StaffSettings.createStaffCode",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.createStaffCode",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "createStaffCode",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "createStaffCode",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  rotateStaffCode: [
    {
      id: "settings-users::StaffSettings.rotateStaffCode",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.rotateStaffCode",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "rotateStaffCode",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "rotateStaffCode",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  revokeStaffCode: [
    {
      id: "settings-users::StaffSettings.revokeStaffCode",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.revokeStaffCode",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "revokeStaffCode",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "revokeStaffCode",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  listApprovedDomains: [
    {
      id: "settings-users::StaffSettings.listApprovedDomains",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.listApprovedDomains",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "listApprovedDomains",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "SettingsTransport",
        rootField: "domainSettingsQuery",
        document:
          "query SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsQuery",
          operationId: "listApprovedDomains",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  addApprovedDomain: [
    {
      id: "settings-users::StaffSettings.addApprovedDomain",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.addApprovedDomain",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "addApprovedDomain",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "addApprovedDomain",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  removeApprovedDomain: [
    {
      id: "settings-users::StaffSettings.removeApprovedDomain",
      moduleId: "settings",
      routeId: "settings-users",
      semanticPath: "/admin/settings/staff/users",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.removeApprovedDomain",
      runtimeBindingRequired: true,
      verificationReason:
        "Settings users is an admin-governed route and must prove with the admin auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "removeApprovedDomain",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SettingsTransport",
        rootField: "domainSettingsMutation",
        document:
          "mutation SettingsTransport($operationId: String!, $input: AWSJSON) {\n  domainSettingsMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainSettingsMutation",
          operationId: "removeApprovedDomain",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  getFinancialAidHistoricalImportTemplate: [
    {
      id: "settings-financial-aid::StaffSettings.getFinancialAidImportTemplate",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.getFinancialAidImportTemplate",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "getFinancialAidHistoricalImportTemplate",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFinancialAidHistoricalImportTemplate",
        rootField: "getFinancialAidHistoricalImportTemplate",
        document:
          "query GetFinancialAidHistoricalImportTemplate($moduleKey: String, $orgId: String) {\n  getFinancialAidHistoricalImportTemplate(moduleKey: $moduleKey, orgId: $orgId) {\n    downloadUrl\n    templateVersion\n    fileName\n    expiresAt\n  }\n}",
        defaultVariables: {
          moduleKey: "staff_settings",
        },
      },
    },
  ],
  requestFinancialAidHistoricalImportUpload: [
    {
      id: "settings-financial-aid::StaffSettings.requestFinancialAidImportUpload",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.requestFinancialAidImportUpload",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "requestFinancialAidHistoricalImportUpload",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFinancialAidHistoricalImportUpload",
        rootField: "requestFinancialAidHistoricalImportUpload",
        document:
          "mutation RequestFinancialAidHistoricalImportUpload($input: AWSJSON!) {\n  requestFinancialAidHistoricalImportUpload(input: $input) {\n    importId\n    uploadUrl\n    s3Key\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  startFinancialAidHistoricalImport: [
    {
      id: "settings-financial-aid::StaffSettings.startFinancialAidImport",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "mutation",
      op: "StaffSettings.startFinancialAidImport",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "startFinancialAidHistoricalImport",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StartFinancialAidHistoricalImport",
        rootField: "startFinancialAidHistoricalImport",
        document:
          "mutation StartFinancialAidHistoricalImport($input: AWSJSON!) {\n  startFinancialAidHistoricalImport(input: $input) {\n    status\n    importId\n    templateVersion\n    lastFileName\n    lastS3Key\n    lastImportedAt\n    processedRows\n    acceptedRows\n    rejectedRows\n    errorSummary\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  getFinancialAidHistoricalImportStatus: [
    {
      id: "settings-financial-aid::StaffSettings.getFinancialAidImportStatus",
      moduleId: "settings",
      routeId: "settings-financial-aid",
      semanticPath: "/admin/settings/staff/financial-aid",
      persona: "staff",
      boundedContext: "StaffSettings",
      aggregateRoot: "SettingsState",
      kind: "query",
      op: "StaffSettings.getFinancialAidImportStatus",
      runtimeBindingRequired: true,
      verificationReason:
        "Financial-aid settings are administrator-governed even though the semantic path remains under the staff taxonomy.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/settings.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/settings-local",
        domainContractRef:
          "artifacts/external-ui-scan/settings-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainSettingsApi",
        operationId: "getFinancialAidHistoricalImportStatus",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StaffSettingsDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFinancialAidHistoricalImportStatus",
        rootField: "getFinancialAidHistoricalImportStatus",
        document:
          "query GetFinancialAidHistoricalImportStatus($importId: String, $moduleKey: String, $orgId: String) {\n  getFinancialAidHistoricalImportStatus(importId: $importId, moduleKey: $moduleKey, orgId: $orgId) {\n    status\n    importId\n    templateVersion\n    lastFileName\n    lastS3Key\n    lastImportedAt\n    processedRows\n    acceptedRows\n    rejectedRows\n    errorSummary\n  }\n}",
        defaultVariables: {
          moduleKey: "staff_settings",
        },
      },
    },
  ],
  listPortalStudentProfiles: [
    {
      id: "portal-family-dashboard::ParentPortal.listFamilies",
      moduleId: "parent-portal",
      routeId: "portal-family-dashboard",
      semanticPath: "/portal/family/dashboard",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.listFamilies",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent dashboard route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-shell::ParentPortal.getDashboardShell",
      moduleId: "parent-portal",
      routeId: "portal-family-shell",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getDashboardShell",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-applications::ParentPortal.listApplications",
      moduleId: "parent-portal",
      routeId: "portal-family-applications",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.listApplications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent tuition route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-enrollment::ParentPortal.getEnrollmentStatus",
      moduleId: "parent-portal",
      routeId: "portal-family-enrollment",
      semanticPath: "/portal/family/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getEnrollmentStatus",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-attendance::ParentPortal.getAttendanceSummary",
      moduleId: "parent-portal",
      routeId: "portal-family-attendance",
      semanticPath: "/portal/family/attendance",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getAttendanceSummary",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent attendance route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[7]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-family-academic::ParentPortal.getAcademicSummary",
      moduleId: "parent-portal",
      routeId: "portal-family-academic",
      semanticPath: "/portal/family/academic",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getAcademicSummary",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent academic route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[8]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-new-family-applications::ParentPortal.getIntakeApplications",
      moduleId: "parent-portal",
      routeId: "portal-new-family-applications",
      semanticPath: "/portal/family/intake/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getIntakeApplications",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake applications route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[10]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
    {
      id: "portal-new-family-enrollment::ParentPortal.getIntakeEnrollment",
      moduleId: "parent-portal",
      routeId: "portal-new-family-enrollment",
      semanticPath: "/portal/family/intake/enrollment",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getIntakeEnrollment",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake enrollment route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[11]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalStudentProfiles",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalStudentProfiles",
        rootField: "listPortalStudentProfiles",
        document:
          "query ListPortalStudentProfiles($input: AWSJSON) {\n  listPortalStudentProfiles(input: $input) {\n    items {\n      id\n      studentName\n      gradeLevel\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
  ],
  markAllNotificationsRead: [
    {
      id: "portal-family-shell::DomainCore.markAllNotificationsRead",
      moduleId: "parent-portal",
      routeId: "portal-family-shell",
      semanticPath: "/portal/family/applications",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "mutation",
      op: "DomainCore.markAllNotificationsRead",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainNotificationsApi",
        operationId: "markAllNotificationsRead",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "NotificationsDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "MarkAllNotificationsRead",
        rootField: "markAllNotificationsRead",
        document:
          "mutation MarkAllNotificationsRead($input: AWSJSON!) {\n  markAllNotificationsRead(input: $input) {\n    updatedCount\n    unreadCount\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  getFinancialAidParentStatusView: [
    {
      id: "portal-family-financial-aid::ParentPortal.getFinancialAidStatus",
      moduleId: "parent-portal",
      routeId: "portal-family-financial-aid",
      semanticPath: "/portal/family/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getFinancialAidStatus",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidParentStatusView",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidParentStatusView",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
    {
      id: "portal-new-family-financial-aid::ParentPortal.getIntakeFinancialAid",
      moduleId: "parent-portal",
      routeId: "portal-new-family-financial-aid",
      semanticPath: "/portal/family/intake/financial-aid",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getIntakeFinancialAid",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent intake financial-aid route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/parent-portal.json#routes[12]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFinancialAidApi",
        operationId: "getFinancialAidParentStatusView",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "FinancialAidDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "FinancialAidTransport",
        rootField: "domainFinancialAidQuery",
        document:
          "query FinancialAidTransport($operationId: String!, $input: AWSJSON) {\n  domainFinancialAidQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainFinancialAidQuery",
          operationId: "getFinancialAidParentStatusView",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        routeParamBindings: [
          {
            param: "applicationId",
            variable: "applicationId",
          },
        ],
        requiredVariables: ["applicationId"],
      },
    },
  ],
  listPortalCalendarEvents: [
    {
      id: "portal-family-calendar::ParentPortal.getCalendarEvents",
      moduleId: "parent-portal",
      routeId: "portal-family-calendar",
      semanticPath: "/portal/family/calendar",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.getCalendarEvents",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent calendar route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[6]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalCalendarEvents",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalCalendarEvents",
        rootField: "listPortalCalendarEvents",
        document:
          "query ListPortalCalendarEvents($input: AWSJSON) {\n  listPortalCalendarEvents(input: $input) {\n    id\n    title\n    startDate\n    endDate\n    location\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
  ],
  listPortalResources: [
    {
      id: "portal-family-resources::ParentPortal.listResources",
      moduleId: "parent-portal",
      routeId: "portal-family-resources",
      semanticPath: "/portal/family/resources",
      persona: "parent",
      boundedContext: "ParentPortal",
      aggregateRoot: "Family",
      kind: "query",
      op: "ParentPortal.listResources",
      runtimeBindingRequired: true,
      verificationReason:
        "Parent resources route proof must use the parent auth lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/parent-portal.json#routes[9]",
        scanBundleRef: "artifacts/external-ui-scan/parent-portal-local",
        domainContractRef:
          "artifacts/external-ui-scan/parent-portal-local/domain-contract.json",
      },
      runtime: {
        routerName: "parentPortalRouter",
        operationId: "listPortalResources",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "ParentPortalDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListPortalResources",
        rootField: "listPortalResources",
        document:
          "query ListPortalResources($input: AWSJSON) {\n  listPortalResources(input: $input) {\n    id\n    title\n    category\n    updatedAt\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
  ],
  listFamilies: [
    {
      id: "students-families-dashboard::DomainCore.listResources",
      moduleId: "students-families",
      routeId: "students-families-dashboard",
      semanticPath: "/admin/students/staff/dashboard",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listResources",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "listFamilies",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFamilies",
        rootField: "listFamilies",
        document:
          "query ListFamilies($input: AWSJSON) {\n  listFamilies(input: $input) {\n    items {\n      id\n      familyName\n      status\n    }\n    totalCount\n    nextToken\n  }\n}",
        defaultVariables: {
          input: {},
        },
      },
    },
  ],
  getFamily: [
    {
      id: "students-families-children::DomainCore.getResourceDetail",
      moduleId: "students-families",
      routeId: "students-families-children",
      semanticPath: "/admin/students/staff/family/:familyId/children",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.getResourceDetail",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getFamily",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFamily",
        rootField: "getFamily",
        document:
          "query GetFamily($familyId: String!) {\n  getFamily(familyId: $familyId) {\n    family {\n      id\n      familyName\n      address {\n        street\n        city\n        state\n        zipCode\n      }\n      homePhone\n      status\n      workflowStatus\n      synagogue\n      rabbi\n      hebrewFamilyName\n      maritalStatus\n      adoptedChild\n      stepParent\n      siblings {\n        name\n        age\n        school\n      }\n      grandparents {\n        paternal {\n          names\n          location\n          phone\n          family\n        }\n        maternal {\n          names\n          location\n          phone\n          family\n        }\n      }\n      paternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      maternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      updatedAt\n    }\n    students {\n      id\n      familyId\n      firstName\n      lastName\n      grade\n      status\n      updatedAt\n    }\n    parentContacts {\n      id\n      familyId\n      firstName\n      lastName\n      email\n      phone\n      relation\n      isPrimary\n      title\n      prefix\n      maidenName\n      occupation\n      firm\n      receivesComms\n      createdAt\n    }\n  }\n}",
        routeParamBindings: [
          {
            param: "familyId",
            variable: "familyId",
          },
        ],
        requiredVariables: ["familyId"],
      },
    },
    {
      id: "students-families-family::DomainCore.getResourceDetail",
      moduleId: "students-families",
      routeId: "students-families-family",
      semanticPath: "/admin/students/staff/family/:familyId/family",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.getResourceDetail",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getFamily",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFamily",
        rootField: "getFamily",
        document:
          "query GetFamily($familyId: String!) {\n  getFamily(familyId: $familyId) {\n    family {\n      id\n      familyName\n      address {\n        street\n        city\n        state\n        zipCode\n      }\n      homePhone\n      status\n      workflowStatus\n      synagogue\n      rabbi\n      hebrewFamilyName\n      maritalStatus\n      adoptedChild\n      stepParent\n      siblings {\n        name\n        age\n        school\n      }\n      grandparents {\n        paternal {\n          names\n          location\n          phone\n          family\n        }\n        maternal {\n          names\n          location\n          phone\n          family\n        }\n      }\n      paternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      maternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      updatedAt\n    }\n    students {\n      id\n      familyId\n      firstName\n      lastName\n      grade\n      status\n      updatedAt\n    }\n    parentContacts {\n      id\n      familyId\n      firstName\n      lastName\n      email\n      phone\n      relation\n      isPrimary\n      title\n      prefix\n      maidenName\n      occupation\n      firm\n      receivesComms\n      createdAt\n    }\n  }\n}",
        routeParamBindings: [
          {
            param: "familyId",
            variable: "familyId",
          },
        ],
        requiredVariables: ["familyId"],
      },
    },
    {
      id: "students-families-tuition::DomainCore.getResourceDetail",
      moduleId: "students-families",
      routeId: "students-families-tuition",
      semanticPath: "/admin/students/staff/family/:familyId/tuition",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.getResourceDetail",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getFamily",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFamily",
        rootField: "getFamily",
        document:
          "query GetFamily($familyId: String!) {\n  getFamily(familyId: $familyId) {\n    family {\n      id\n      familyName\n      address {\n        street\n        city\n        state\n        zipCode\n      }\n      homePhone\n      status\n      workflowStatus\n      synagogue\n      rabbi\n      hebrewFamilyName\n      maritalStatus\n      adoptedChild\n      stepParent\n      siblings {\n        name\n        age\n        school\n      }\n      grandparents {\n        paternal {\n          names\n          location\n          phone\n          family\n        }\n        maternal {\n          names\n          location\n          phone\n          family\n        }\n      }\n      paternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      maternalGrandparents {\n        names\n        location\n        phone\n        family\n      }\n      updatedAt\n    }\n    students {\n      id\n      familyId\n      firstName\n      lastName\n      grade\n      status\n      updatedAt\n    }\n    parentContacts {\n      id\n      familyId\n      firstName\n      lastName\n      email\n      phone\n      relation\n      isPrimary\n      title\n      prefix\n      maidenName\n      occupation\n      firm\n      receivesComms\n      createdAt\n    }\n  }\n}",
        routeParamBindings: [
          {
            param: "familyId",
            variable: "familyId",
          },
        ],
        requiredVariables: ["familyId"],
      },
    },
  ],
  listFamilyDocuments: [
    {
      id: "students-families-documents::DomainCore.listResourceDocuments",
      moduleId: "students-families",
      routeId: "students-families-documents",
      semanticPath: "/admin/students/staff/family/:familyId/documents",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listResourceDocuments",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "listFamilyDocuments",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFamilyDocuments",
        rootField: "listFamilyDocuments",
        document:
          "query ListFamilyDocuments($familyId: String!, $limit: Int, $nextToken: String) {\n  listFamilyDocuments(familyId: $familyId, limit: $limit, nextToken: $nextToken) {\n    items {\n      id\n      familyId\n      studentId\n      documentGroupId\n      fileName\n      status\n      uploadedAt\n    }\n    totalCount\n    nextToken\n  }\n}",
        routeParamBindings: [
          {
            param: "familyId",
            variable: "familyId",
          },
        ],
        requiredVariables: ["familyId"],
        defaultVariables: {
          limit: 25,
        },
      },
    },
  ],
  requestFamilyDocumentUpload: [
    {
      id: "students-families-documents::DomainCore.uploadResourceDocument",
      moduleId: "students-families",
      routeId: "students-families-documents",
      semanticPath: "/admin/students/staff/family/:familyId/documents",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "DomainCore.uploadResourceDocument",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "requestFamilyDocumentUpload",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFamilyDocumentUpload",
        rootField: "requestFamilyDocumentUpload",
        document:
          "mutation RequestFamilyDocumentUpload($input: AWSJSON!) {\n  requestFamilyDocumentUpload(input: $input) {\n    uploadUrl\n    storageKey\n    resourceId\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-dashboard::StudentsFamilies.requestFamilyDocumentUpload",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.requestFamilyDocumentUpload",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "requestFamilyDocumentUpload",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFamilyDocumentUpload",
        rootField: "requestFamilyDocumentUpload",
        document:
          "mutation RequestFamilyDocumentUpload($input: AWSJSON!) {\n  requestFamilyDocumentUpload(input: $input) {\n    uploadUrl\n    storageKey\n    resourceId\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  listFamilyTimelineEvents: [
    {
      id: "students-families-notes::DomainCore.listResourceNotes",
      moduleId: "students-families",
      routeId: "students-families-notes",
      semanticPath: "/admin/students/staff/family/:familyId/notes",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "query",
      op: "DomainCore.listResourceNotes",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "listFamilyTimelineEvents",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFamilyTimelineEvents",
        rootField: "listFamilyTimelineEvents",
        document:
          "query ListFamilyTimelineEvents($familyId: String!, $limit: Int, $nextToken: String) {\n  listFamilyTimelineEvents(familyId: $familyId, limit: $limit, nextToken: $nextToken) {\n    items {\n      id\n      familyId\n      studentId\n      eventType\n      title\n      content\n      createdAt\n      updatedAt\n    }\n    nextToken\n  }\n}",
        routeParamBindings: [
          {
            param: "familyId",
            variable: "familyId",
          },
        ],
        requiredVariables: ["familyId"],
        defaultVariables: {
          limit: 25,
        },
      },
    },
  ],
  createFamilyNote: [
    {
      id: "students-families-notes::DomainCore.addResourceNote",
      moduleId: "students-families",
      routeId: "students-families-notes",
      semanticPath: "/admin/students/staff/family/:familyId/notes",
      persona: "staff",
      boundedContext: "DomainCore",
      aggregateRoot: "Resource",
      kind: "mutation",
      op: "DomainCore.addResourceNote",
      runtimeBindingRequired: true,
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/students-families.json#routes[5]",
        scanBundleRef: "artifacts/external-ui-scan/students-families-local",
        domainContractRef:
          "artifacts/external-ui-scan/students-families-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createFamilyNote",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "CreateFamilyNote",
        rootField: "createFamilyNote",
        document:
          "mutation CreateFamilyNote($input: AWSJSON!) {\n  createFamilyNote(input: $input) {\n    id\n    familyId\n    studentId\n    eventType\n    title\n    content\n    createdAt\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  listFaculty: [
    {
      id: "faculty-directory::Faculty.listFacultyDirectory",
      moduleId: "faculty",
      routeId: "faculty-directory",
      semanticPath: "/school/faculty",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "query",
      op: "Faculty.listFacultyDirectory",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "listFaculty",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFaculty",
        rootField: "listFaculty",
        document:
          "query ListFaculty($filter: AWSJSON) {\n  listFaculty(filter: $filter) {\n    items {\n      id\n      orgId\n      firstName\n      middleName\n      lastName\n      displayName\n      preferredName\n      hebrewFirstName\n      hebrewLastName\n      dateOfBirth\n      gender\n      profilePhotoUrl\n      personalEmail\n      email\n      phone\n      homePhone\n      address\n      employeeId\n      hireDate\n      position\n      employmentType\n      divisions\n      gradeLevels\n      subjectLabels\n      homeroom\n      reportsTo\n      tags\n      resourceId\n      primaryDivisionId\n      status\n      invitedAt\n      activatedAt\n      createdAt\n      updatedAt\n    }\n    nextToken\n  }\n}",
        defaultVariables: {
          filter: {},
        },
      },
    },
  ],
  createFaculty: [
    {
      id: "faculty-directory::Faculty.createFaculty",
      moduleId: "faculty",
      routeId: "faculty-directory",
      semanticPath: "/school/faculty",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.createFaculty",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "createFaculty",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "CreateFaculty",
        rootField: "createFaculty",
        document:
          "mutation CreateFaculty($input: AWSJSON!) {\n  createFaculty(input: $input) {\n    id\n    orgId\n    status\n    firstName\n    lastName\n    displayName\n    middleName\n    preferredName\n    hebrewFirstName\n    hebrewLastName\n    dateOfBirth\n    gender\n    profilePhotoUrl\n    email\n    personalEmail\n    phone\n    homePhone\n    address\n    employeeId\n    hireDate\n    position\n    employmentType\n    divisions\n    gradeLevels\n    subjectLabels\n    homeroom\n    reportsTo\n    tags\n    userId\n    externalId\n    resourceId\n    primaryDivisionId\n    invitedAt\n    activatedAt\n    createdAt\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  updateFaculty: [
    {
      id: "faculty-directory::Faculty.updateFaculty",
      moduleId: "faculty",
      routeId: "faculty-directory",
      semanticPath: "/school/faculty",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.updateFaculty",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "updateFaculty",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateFaculty",
        rootField: "updateFaculty",
        document:
          "mutation UpdateFaculty($input: AWSJSON!) {\n  updateFaculty(input: $input) {\n    id\n    orgId\n    status\n    firstName\n    lastName\n    displayName\n    middleName\n    preferredName\n    hebrewFirstName\n    hebrewLastName\n    dateOfBirth\n    gender\n    profilePhotoUrl\n    email\n    personalEmail\n    phone\n    homePhone\n    address\n    employeeId\n    hireDate\n    position\n    employmentType\n    divisions\n    gradeLevels\n    subjectLabels\n    homeroom\n    reportsTo\n    tags\n    userId\n    externalId\n    resourceId\n    primaryDivisionId\n    invitedAt\n    activatedAt\n    createdAt\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile::Faculty.updateFaculty",
      moduleId: "faculty",
      routeId: "faculty-profile",
      semanticPath: "/school/faculty/profile",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.updateFaculty",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "updateFaculty",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "UpdateFaculty",
        rootField: "updateFaculty",
        document:
          "mutation UpdateFaculty($input: AWSJSON!) {\n  updateFaculty(input: $input) {\n    id\n    orgId\n    status\n    firstName\n    lastName\n    displayName\n    middleName\n    preferredName\n    hebrewFirstName\n    hebrewLastName\n    dateOfBirth\n    gender\n    profilePhotoUrl\n    email\n    personalEmail\n    phone\n    homePhone\n    address\n    employeeId\n    hireDate\n    position\n    employmentType\n    divisions\n    gradeLevels\n    subjectLabels\n    homeroom\n    reportsTo\n    tags\n    userId\n    externalId\n    resourceId\n    primaryDivisionId\n    invitedAt\n    activatedAt\n    createdAt\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  addFacultyAssignment: [
    {
      id: "faculty-directory::Faculty.addAssignment",
      moduleId: "faculty",
      routeId: "faculty-directory",
      semanticPath: "/school/faculty",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.addAssignment",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "addFacultyAssignment",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AddFacultyAssignment",
        rootField: "addFacultyAssignment",
        document:
          "mutation AddFacultyAssignment($input: AWSJSON!) {\n  addFacultyAssignment(input: $input) {\n    assignmentType\n    divisionAssignment {\n      id\n      facultyId\n      divisionId\n      assignmentType\n      isPrimary\n      startAt\n      endAt\n      allowOverlap\n      createdAt\n      updatedAt\n    }\n    teachingAssignment {\n      id\n      facultyId\n      academicYear\n      termId\n      courseId\n      sectionId\n      role\n      divisionLabel\n      gradeLabel\n      subjectLabel\n      room\n      homeroom\n      studentCount\n      startAt\n      endAt\n      createdAt\n      updatedAt\n    }\n    schedule {\n      id\n      facultyId\n      academicYear\n      termId\n      template {\n        day\n        period\n        startMinute\n        endMinute\n        label\n        location\n        blockType\n        gradeLabel\n        subjectLabel\n        room\n      }\n      exceptions {\n        date\n        reason\n        cancelled\n        overrideBlocks {\n          day\n          period\n          startMinute\n          endMinute\n          label\n          location\n          blockType\n          gradeLabel\n          subjectLabel\n          room\n        }\n      }\n      createdAt\n      updatedAt\n    }\n    emergencyContact {\n      id\n      facultyId\n      name\n      relationship\n      phone\n      alternatePhone\n      email\n      priority\n      consentProvided\n      createdAt\n      updatedAt\n    }\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile::Faculty.addAssignment",
      moduleId: "faculty",
      routeId: "faculty-profile",
      semanticPath: "/school/faculty/profile",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.addAssignment",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "addFacultyAssignment",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AddFacultyAssignment",
        rootField: "addFacultyAssignment",
        document:
          "mutation AddFacultyAssignment($input: AWSJSON!) {\n  addFacultyAssignment(input: $input) {\n    assignmentType\n    divisionAssignment {\n      id\n      facultyId\n      divisionId\n      assignmentType\n      isPrimary\n      startAt\n      endAt\n      allowOverlap\n      createdAt\n      updatedAt\n    }\n    teachingAssignment {\n      id\n      facultyId\n      academicYear\n      termId\n      courseId\n      sectionId\n      role\n      divisionLabel\n      gradeLabel\n      subjectLabel\n      room\n      homeroom\n      studentCount\n      startAt\n      endAt\n      createdAt\n      updatedAt\n    }\n    schedule {\n      id\n      facultyId\n      academicYear\n      termId\n      template {\n        day\n        period\n        startMinute\n        endMinute\n        label\n        location\n        blockType\n        gradeLabel\n        subjectLabel\n        room\n      }\n      exceptions {\n        date\n        reason\n        cancelled\n        overrideBlocks {\n          day\n          period\n          startMinute\n          endMinute\n          label\n          location\n          blockType\n          gradeLabel\n          subjectLabel\n          room\n        }\n      }\n      createdAt\n      updatedAt\n    }\n    emergencyContact {\n      id\n      facultyId\n      name\n      relationship\n      phone\n      alternatePhone\n      email\n      priority\n      consentProvided\n      createdAt\n      updatedAt\n    }\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile-teaching::Faculty.addAssignment",
      moduleId: "faculty",
      routeId: "faculty-profile-teaching",
      semanticPath: "/school/faculty/profile/teaching",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.addAssignment",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "addFacultyAssignment",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AddFacultyAssignment",
        rootField: "addFacultyAssignment",
        document:
          "mutation AddFacultyAssignment($input: AWSJSON!) {\n  addFacultyAssignment(input: $input) {\n    assignmentType\n    divisionAssignment {\n      id\n      facultyId\n      divisionId\n      assignmentType\n      isPrimary\n      startAt\n      endAt\n      allowOverlap\n      createdAt\n      updatedAt\n    }\n    teachingAssignment {\n      id\n      facultyId\n      academicYear\n      termId\n      courseId\n      sectionId\n      role\n      divisionLabel\n      gradeLabel\n      subjectLabel\n      room\n      homeroom\n      studentCount\n      startAt\n      endAt\n      createdAt\n      updatedAt\n    }\n    schedule {\n      id\n      facultyId\n      academicYear\n      termId\n      template {\n        day\n        period\n        startMinute\n        endMinute\n        label\n        location\n        blockType\n        gradeLabel\n        subjectLabel\n        room\n      }\n      exceptions {\n        date\n        reason\n        cancelled\n        overrideBlocks {\n          day\n          period\n          startMinute\n          endMinute\n          label\n          location\n          blockType\n          gradeLabel\n          subjectLabel\n          room\n        }\n      }\n      createdAt\n      updatedAt\n    }\n    emergencyContact {\n      id\n      facultyId\n      name\n      relationship\n      phone\n      alternatePhone\n      email\n      priority\n      consentProvided\n      createdAt\n      updatedAt\n    }\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  exportFacultyDirectory: [
    {
      id: "faculty-directory::Faculty.exportFacultyDirectory",
      moduleId: "faculty",
      routeId: "faculty-directory",
      semanticPath: "/school/faculty",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.exportFacultyDirectory",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[0]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "exportFacultyDirectory",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "ExportFacultyDirectory",
        rootField: "exportFacultyDirectory",
        document:
          "mutation ExportFacultyDirectory($input: AWSJSON!) {\n  exportFacultyDirectory(input: $input) {\n    downloadUrl\n    fileName\n    contentType\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  getFaculty: [
    {
      id: "faculty-profile::Faculty.getFacultyProfile",
      moduleId: "faculty",
      routeId: "faculty-profile",
      semanticPath: "/school/faculty/profile",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "query",
      op: "Faculty.getFacultyProfile",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "getFaculty",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "GetFaculty",
        rootField: "getFaculty",
        document:
          "query GetFaculty($facultyId: String!) {\n  getFaculty(facultyId: $facultyId) {\n    id\n    orgId\n    firstName\n    middleName\n    lastName\n    displayName\n    preferredName\n    hebrewFirstName\n    hebrewLastName\n    dateOfBirth\n    gender\n    profilePhotoUrl\n    personalEmail\n    email\n    phone\n    homePhone\n    address\n    employeeId\n    hireDate\n    position\n    employmentType\n    divisions\n    gradeLevels\n    subjectLabels\n    homeroom\n    reportsTo\n    tags\n    resourceId\n    primaryDivisionId\n    status\n    invitedAt\n    activatedAt\n    createdAt\n    updatedAt\n  }\n}",
        routeParamBindings: [
          {
            param: "facultyId",
            variable: "facultyId",
          },
        ],
        requiredVariables: ["facultyId"],
      },
    },
  ],
  requestFacultyAssetUpload: [
    {
      id: "faculty-profile::Faculty.requestAssetUpload",
      moduleId: "faculty",
      routeId: "faculty-profile",
      semanticPath: "/school/faculty/profile",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.requestAssetUpload",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[1]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "requestFacultyAssetUpload",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFacultyAssetUpload",
        rootField: "requestFacultyAssetUpload",
        document:
          "mutation RequestFacultyAssetUpload($input: AWSJSON!) {\n  requestFacultyAssetUpload(input: $input) {\n    uploadUrl\n    storageKey\n    resourceId\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile-notes::Faculty.requestAssetUpload",
      moduleId: "faculty",
      routeId: "faculty-profile-notes",
      semanticPath: "/school/faculty/profile/notes",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.requestAssetUpload",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "requestFacultyAssetUpload",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFacultyAssetUpload",
        rootField: "requestFacultyAssetUpload",
        document:
          "mutation RequestFacultyAssetUpload($input: AWSJSON!) {\n  requestFacultyAssetUpload(input: $input) {\n    uploadUrl\n    storageKey\n    resourceId\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
    {
      id: "faculty-profile-communications::Faculty.requestAssetUpload",
      moduleId: "faculty",
      routeId: "faculty-profile-communications",
      semanticPath: "/school/faculty/profile/communications",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.requestAssetUpload",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "requestFacultyAssetUpload",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "RequestFacultyAssetUpload",
        rootField: "requestFacultyAssetUpload",
        document:
          "mutation RequestFacultyAssetUpload($input: AWSJSON!) {\n  requestFacultyAssetUpload(input: $input) {\n    uploadUrl\n    storageKey\n    resourceId\n    expiresAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  listFacultyAssignments: [
    {
      id: "faculty-profile-teaching::Faculty.listTeachingAssignments",
      moduleId: "faculty",
      routeId: "faculty-profile-teaching",
      semanticPath: "/school/faculty/profile/teaching",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "query",
      op: "Faculty.listTeachingAssignments",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[2]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "listFacultyAssignments",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFacultyAssignments",
        rootField: "listFacultyAssignments",
        document:
          "query ListFacultyAssignments($facultyId: String!, $type: String) {\n  listFacultyAssignments(facultyId: $facultyId, type: $type) {\n    items {\n      assignmentType\n      divisionAssignment {\n        id\n        facultyId\n        divisionId\n        assignmentType\n        isPrimary\n        startAt\n        endAt\n        allowOverlap\n        createdAt\n        updatedAt\n      }\n      teachingAssignment {\n        id\n        facultyId\n        academicYear\n        termId\n        courseId\n        sectionId\n        role\n        divisionLabel\n        gradeLabel\n        subjectLabel\n        room\n        homeroom\n        studentCount\n        startAt\n        endAt\n        createdAt\n        updatedAt\n      }\n      schedule {\n        id\n        facultyId\n        academicYear\n        termId\n        template {\n          day\n          period\n          startMinute\n          endMinute\n          label\n          location\n          blockType\n          gradeLabel\n          subjectLabel\n          room\n        }\n        exceptions {\n          date\n          reason\n          cancelled\n          overrideBlocks {\n            day\n            period\n            startMinute\n            endMinute\n            label\n            location\n            blockType\n            gradeLabel\n            subjectLabel\n            room\n          }\n        }\n        createdAt\n        updatedAt\n      }\n      emergencyContact {\n        id\n        facultyId\n        name\n        relationship\n        phone\n        alternatePhone\n        email\n        priority\n        consentProvided\n        createdAt\n        updatedAt\n      }\n    }\n    nextToken\n  }\n}",
        routeParamBindings: [
          {
            param: "facultyId",
            variable: "facultyId",
          },
        ],
        requiredVariables: ["facultyId"],
      },
    },
  ],
  listFacultyNotes: [
    {
      id: "faculty-profile-notes::Faculty.listNotes",
      moduleId: "faculty",
      routeId: "faculty-profile-notes",
      semanticPath: "/school/faculty/profile/notes",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "query",
      op: "Faculty.listNotes",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "listFacultyNotes",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFacultyNotes",
        rootField: "listFacultyNotes",
        document:
          "query ListFacultyNotes($facultyId: String!) {\n  listFacultyNotes(facultyId: $facultyId) {\n    items {\n      id\n      facultyId\n      authorId\n      authorLabel\n      visibility\n      body\n      category\n      isImportant\n      attachmentName\n      attachments {\n        resourceId\n        fileName\n        contentType\n        sizeBytes\n        storageKey\n        uploadedAt\n      }\n      createdAt\n      updatedAt\n    }\n    nextToken\n  }\n}",
        routeParamBindings: [
          {
            param: "facultyId",
            variable: "facultyId",
          },
        ],
        requiredVariables: ["facultyId"],
      },
    },
  ],
  addFacultyNote: [
    {
      id: "faculty-profile-notes::Faculty.addNote",
      moduleId: "faculty",
      routeId: "faculty-profile-notes",
      semanticPath: "/school/faculty/profile/notes",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.addNote",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[3]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "addFacultyNote",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AddFacultyNote",
        rootField: "addFacultyNote",
        document:
          "mutation AddFacultyNote($input: AWSJSON!) {\n  addFacultyNote(input: $input) {\n    id\n    facultyId\n    authorId\n    authorLabel\n    body\n    visibility\n    category\n    isImportant\n    attachmentName\n    attachments {\n      resourceId\n      fileName\n      contentType\n      sizeBytes\n      storageKey\n      uploadedAt\n    }\n    createdAt\n    updatedAt\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  listFacultyCommunications: [
    {
      id: "faculty-profile-communications::Faculty.listCommunications",
      moduleId: "faculty",
      routeId: "faculty-profile-communications",
      semanticPath: "/school/faculty/profile/communications",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "query",
      op: "Faculty.listCommunications",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "listFacultyCommunications",
        operationKind: "query",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "ListFacultyCommunications",
        rootField: "listFacultyCommunications",
        document:
          "query ListFacultyCommunications($facultyId: String!) {\n  listFacultyCommunications(facultyId: $facultyId) {\n    items {\n      id\n      facultyId\n      channel\n      status\n      senderLabel\n      recipient\n      subject\n      body\n      attachments {\n        resourceId\n        fileName\n        contentType\n        sizeBytes\n        storageKey\n        uploadedAt\n      }\n      outboxId\n      providerMessageId\n      lastError\n      error\n      sentAt\n      createdAt\n      createdBy\n    }\n    nextToken\n  }\n}",
        routeParamBindings: [
          {
            param: "facultyId",
            variable: "facultyId",
          },
        ],
        requiredVariables: ["facultyId"],
      },
    },
  ],
  sendFacultyCommunication: [
    {
      id: "faculty-profile-communications::Faculty.sendCommunication",
      moduleId: "faculty",
      routeId: "faculty-profile-communications",
      semanticPath: "/school/faculty/profile/communications",
      persona: "staff",
      boundedContext: "Faculty",
      aggregateRoot: "Faculty",
      kind: "mutation",
      op: "Faculty.sendCommunication",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/faculty.json#routes[4]",
        scanBundleRef: "artifacts/external-ui-scan/faculty-local",
        domainContractRef:
          "artifacts/external-ui-scan/faculty-local/domain-contract.json",
      },
      runtime: {
        routerName: "domainFacultyApi",
        operationId: "sendFacultyCommunication",
        operationKind: "mutation",
        enforcement: "non-active-bound",
        domainContextTag: "FacultyDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "SendFacultyCommunication",
        rootField: "sendFacultyCommunication",
        document:
          "mutation SendFacultyCommunication($input: AWSJSON!) {\n  sendFacultyCommunication(input: $input) {\n    id\n    facultyId\n    channel\n    status\n    senderLabel\n    recipient\n    subject\n    body\n    attachments {\n      resourceId\n      fileName\n      contentType\n      sizeBytes\n      storageKey\n      uploadedAt\n    }\n    outboxId\n    providerMessageId\n    sentAt\n    lastError\n    error\n    createdAt\n    createdBy\n  }\n}",
        requiredVariables: ["input"],
      },
    },
  ],
  getSchoolTuitionDashboardTree: [
    {
      id: "tuition-school-dashboard::StudentsFamilies.getSchoolTuitionDashboardTree",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.getSchoolTuitionDashboardTree",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getSchoolTuitionDashboardTree",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "getSchoolTuitionDashboardTree",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  previewBulkChargeSegment: [
    {
      id: "tuition-school-dashboard::StudentsFamilies.previewBulkChargeSegment",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.previewBulkChargeSegment",
      notes:
        "Explicit bulk-charge modal/action read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "previewBulkChargeSegment",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "previewBulkChargeSegment",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  getBulkChargeJob: [
    {
      id: "tuition-school-dashboard::StudentsFamilies.getBulkChargeJob",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.getBulkChargeJob",
      notes:
        "Explicit bulk-charge job/status action read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getBulkChargeJob",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "getBulkChargeJob",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  getFamilyDocumentDownloadUrl: [
    {
      id: "tuition-school-dashboard::StudentsFamilies.getFamilyDocumentDownloadUrl",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.getFamilyDocumentDownloadUrl",
      notes:
        "Explicit artifact download action read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getFamilyDocumentDownloadUrl",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "getFamilyDocumentDownloadUrl",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.getFamilyDocumentDownloadUrl",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.getFamilyDocumentDownloadUrl",
      notes:
        "Explicit artifact download action read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getFamilyDocumentDownloadUrl",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "getFamilyDocumentDownloadUrl",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  createFamilyBillingEntry: [
    {
      id: "tuition-school-dashboard::StudentsFamilies.createFamilyBillingEntry",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.createFamilyBillingEntry",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createFamilyBillingEntry",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "createFamilyBillingEntry",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
    {
      id: "tuition-school-family-ledger::StudentsFamilies.createFamilyBillingEntry",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.createFamilyBillingEntry",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createFamilyBillingEntry",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "createFamilyBillingEntry",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  createBulkCharge: [
    {
      id: "tuition-school-dashboard::StudentsFamilies.createBulkCharge",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.createBulkCharge",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createBulkCharge",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "createBulkCharge",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  createFamilyDocumentRecord: [
    {
      id: "tuition-school-dashboard::StudentsFamilies.createFamilyDocumentRecord",
      moduleId: "school-tuition",
      routeId: "tuition-school-dashboard",
      semanticPath: "/admin/tuition/staff/dashboard",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.createFamilyDocumentRecord",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition dashboard proves against the staff finance lane.",
      routeParamKeys: [],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[0]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createFamilyDocumentRecord",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "createFamilyDocumentRecord",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  getSchoolTuitionFamilyLedgerTree: [
    {
      id: "tuition-school-family-ledger::StudentsFamilies.getSchoolTuitionFamilyLedgerTree",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.getSchoolTuitionFamilyLedgerTree",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "getSchoolTuitionFamilyLedgerTree",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "getSchoolTuitionFamilyLedgerTree",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  listRecurringFeeDefinitions: [
    {
      id: "tuition-school-family-ledger::StudentsFamilies.listRecurringFeeDefinitions",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.listRecurringFeeDefinitions",
      notes:
        "Explicit recurring-fee management modal read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "listRecurringFeeDefinitions",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "listRecurringFeeDefinitions",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  listRecurringFeeAssignments: [
    {
      id: "tuition-school-family-ledger::StudentsFamilies.listRecurringFeeAssignments",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "query",
      op: "StudentsFamilies.listRecurringFeeAssignments",
      notes:
        "Explicit recurring-fee management modal read; not initial route hydration.",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "listRecurringFeeAssignments",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesQuery",
        document:
          "query StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesQuery",
          operationId: "listRecurringFeeAssignments",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  createAdHocCharge: [
    {
      id: "tuition-school-family-ledger::StudentsFamilies.createAdHocCharge",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.createAdHocCharge",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "createAdHocCharge",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "createAdHocCharge",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  archiveAdHocTuitionCharge: [
    {
      id: "tuition-school-family-ledger::StudentsFamilies.archiveAdHocTuitionCharge",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.archiveAdHocTuitionCharge",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "archiveAdHocTuitionCharge",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "archiveAdHocTuitionCharge",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  assignRecurringFee: [
    {
      id: "tuition-school-family-ledger::StudentsFamilies.assignRecurringFee",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.assignRecurringFee",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "assignRecurringFee",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "assignRecurringFee",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  unassignRecurringFee: [
    {
      id: "tuition-school-family-ledger::StudentsFamilies.unassignRecurringFee",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.unassignRecurringFee",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "unassignRecurringFee",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "unassignRecurringFee",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  bulkAssignRecurringFee: [
    {
      id: "tuition-school-family-ledger::StudentsFamilies.bulkAssignRecurringFee",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.bulkAssignRecurringFee",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "bulkAssignRecurringFee",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "bulkAssignRecurringFee",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  reverseTuitionPayment: [
    {
      id: "tuition-school-family-ledger::StudentsFamilies.reverseTuitionPayment",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.reverseTuitionPayment",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "reverseTuitionPayment",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "reverseTuitionPayment",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  issueTuitionRefund: [
    {
      id: "tuition-school-family-ledger::StudentsFamilies.issueTuitionRefund",
      moduleId: "school-tuition",
      routeId: "tuition-school-family-ledger",
      semanticPath: "/admin/tuition/staff/family/:familyId",
      persona: "staff",
      boundedContext: "StudentsFamilies",
      aggregateRoot: "FamilyAccount",
      kind: "mutation",
      op: "StudentsFamilies.issueTuitionRefund",
      runtimeBindingRequired: true,
      verificationReason:
        "School tuition family ledger proof must use the staff tuition lane.",
      routeParamKeys: ["familyId"],
      evidence: {
        semanticRouteRef:
          "config/semantic-routes/school-tuition.json#routes[1]",
        routingRef: "config/routes/canonical-routes.json",
      },
      runtime: {
        routerName: "domainStudentsFamiliesApi",
        operationId: "issueTuitionRefund",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "StudentsFamiliesDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "StudentsFamiliesTransport",
        rootField: "domainStudentsFamiliesMutation",
        document:
          "mutation StudentsFamiliesTransport($operationId: String!, $input: AWSJSON) {\n  domainStudentsFamiliesMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "domainStudentsFamiliesMutation",
          operationId: "issueTuitionRefund",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  getAssistantReportGenerationWorkspace: [
    {
      id: "school-run-reports::AssistantPlatform.getAssistantReportGenerationWorkspace",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "query",
      op: "AssistantPlatform.getAssistantReportGenerationWorkspace",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "getAssistantReportGenerationWorkspace",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "getAssistantReportGenerationWorkspace",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  getAssistantSessionState: [
    {
      id: "school-run-reports::AssistantPlatform.getAssistantSessionState",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "query",
      op: "AssistantPlatform.getAssistantSessionState",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "getAssistantSessionState",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "getAssistantSessionState",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  listAssistantWorkItems: [
    {
      id: "school-run-reports::AssistantPlatform.listAssistantWorkItems",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "query",
      op: "AssistantPlatform.listAssistantWorkItems",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "listAssistantWorkItems",
        operationKind: "query",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "query",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformQuery",
        document:
          "query AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformQuery(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformQuery",
          operationId: "listAssistantWorkItems",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        defaultVariables: {},
      },
    },
  ],
  mutateAssistantReportTemplate: [
    {
      id: "school-run-reports::AssistantPlatform.mutateAssistantReportTemplate",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "mutation",
      op: "AssistantPlatform.mutateAssistantReportTemplate",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "mutateAssistantReportTemplate",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "mutateAssistantReportTemplate",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
  mutateAssistantReportSchedule: [
    {
      id: "school-run-reports::AssistantPlatform.mutateAssistantReportSchedule",
      moduleId: "run-reports",
      routeId: "school-run-reports",
      semanticPath: "/admin/run-reports",
      persona: "staff",
      boundedContext: "AssistantPlatform",
      aggregateRoot: "AssistantReportGeneration",
      kind: "mutation",
      op: "AssistantPlatform.mutateAssistantReportSchedule",
      runtimeBindingRequired: true,
      routeParamKeys: [],
      evidence: {
        semanticRouteRef: "config/semantic-routes/run-reports.json#routes[0]",
      },
      runtime: {
        routerName: "assistantPlatformContractApi",
        operationId: "mutateAssistantReportSchedule",
        operationKind: "mutation",
        enforcement: "active",
        domainContextTag: "AssistantPlatformDomain",
      },
      graphql: {
        operationType: "mutation",
        operationName: "AssistantPlatformTransport",
        rootField: "assistantPlatformMutation",
        document:
          "mutation AssistantPlatformTransport($operationId: String!, $input: AWSJSON) {\n  assistantPlatformMutation(operationId: $operationId, input: $input) {\n    operationId\n    payload\n  }\n}",
        transport: {
          transportField: "assistantPlatformMutation",
          operationId: "mutateAssistantReportSchedule",
          serializer: "domain-router-awsjson",
          inputVariable: "input",
        },
        requiredVariables: ["input"],
      },
    },
  ],
});

export const ystnjQueryOperationContext: Readonly<Record<string, string>> =
  Object.freeze({
    listApplications: "AdmissionsDomain",
    listNotifications: "NotificationsDomain",
    getApplication: "AdmissionsDomain",
    getNotification: "NotificationsDomain",
    getAdmissionsTuitionConfiguration: "AdmissionsDomain",
    listFinancialAidApplicationsForReview: "FinancialAidDomain",
    getFinancialAidDocumentStatus: "FinancialAidDomain",
    getFinancialAidApplicationForReview: "FinancialAidDomain",
    getFinancialAidStatusHistory: "FinancialAidDomain",
    getPayrollDashboard: "PayrollDomain",
    getPayrollEmployeeDetail: "PayrollDomain",
    listPayrollAuditLog: "PayrollDomain",
    getModuleConfig: "StaffSettingsDomain",
    listModuleEnablementAuditEvents: "StaffSettingsDomain",
    listNotificationPreferences: "NotificationsDomain",
    getAssistantSpreadsheetBridgeStatus: "AssistantIntegrationsDomain",
    getPaymentControlPlaneReadiness: "PaymentsDomain",
    listAssistantWorkflowTemplates: "AssistantPlatformDomain",
    getAssistantWorkflow: "AssistantPlatformDomain",
    listAssistantWorkflowExecutions: "AssistantPlatformDomain",
    listStaffUsers: "StaffSettingsDomain",
    listStaffCodes: "StaffSettingsDomain",
    listApprovedDomains: "StaffSettingsDomain",
    getFinancialAidHistoricalImportTemplate: "StaffSettingsDomain",
    getFinancialAidHistoricalImportStatus: "StaffSettingsDomain",
    listPortalStudentProfiles: "ParentPortalDomain",
    getFinancialAidParentStatusView: "FinancialAidDomain",
    listPortalCalendarEvents: "ParentPortalDomain",
    listPortalResources: "ParentPortalDomain",
    listFamilies: "StudentsFamiliesDomain",
    getFamily: "StudentsFamiliesDomain",
    listFamilyDocuments: "StudentsFamiliesDomain",
    listFamilyTimelineEvents: "StudentsFamiliesDomain",
    listFaculty: "FacultyDomain",
    getFaculty: "FacultyDomain",
    listFacultyAssignments: "FacultyDomain",
    listFacultyNotes: "FacultyDomain",
    listFacultyCommunications: "FacultyDomain",
    getSchoolTuitionDashboardTree: "StudentsFamiliesDomain",
    previewBulkChargeSegment: "StudentsFamiliesDomain",
    getBulkChargeJob: "StudentsFamiliesDomain",
    getFamilyDocumentDownloadUrl: "StudentsFamiliesDomain",
    getSchoolTuitionFamilyLedgerTree: "StudentsFamiliesDomain",
    listRecurringFeeDefinitions: "StudentsFamiliesDomain",
    listRecurringFeeAssignments: "StudentsFamiliesDomain",
    getAssistantReportGenerationWorkspace: "AssistantPlatformDomain",
    getAssistantSessionState: "AssistantPlatformDomain",
    listAssistantWorkItems: "AssistantPlatformDomain",
  });

export const ystnjMutationOperationContext: Readonly<Record<string, string>> =
  Object.freeze({
    markNotificationRead: "NotificationsDomain",
    addNote: "AdmissionsDomain",
    addDocument: "AdmissionsDomain",
    upsertAdmissionsTuitionConfiguration: "AdmissionsDomain",
    generateTuitionContract: "AdmissionsDomain",
    sendTuitionContract: "AdmissionsDomain",
    assignFinancialAidApplication: "FinancialAidDomain",
    uploadFinancialAidDocument: "FinancialAidDomain",
    makeFinancialAidDecision: "FinancialAidDomain",
    updateFinancialAidApplication: "FinancialAidDomain",
    requestFinancialAidMoreInfo: "FinancialAidDomain",
    generateFinancialAidDecisionLetter: "FinancialAidDomain",
    switchPayrollPeriod: "PayrollDomain",
    submitPayrollPeriodForApproval: "PayrollDomain",
    approvePayrollPeriod: "PayrollDomain",
    rejectPayrollPeriod: "PayrollDomain",
    unlockPayrollPeriod: "PayrollDomain",
    exportPayrollPeriod: "PayrollDomain",
    upsertPayrollEmployeeProfile: "PayrollDomain",
    upsertPayrollPosition: "PayrollDomain",
    upsertPayrollStipend: "PayrollDomain",
    upsertPayrollTimeEntry: "PayrollDomain",
    upsertPayrollAdjustment: "PayrollDomain",
    upsertPayrollExternalTuitionPayment: "PayrollDomain",
    upsertPayrollDeductionEntry: "PayrollDomain",
    updateModuleConfig: "StaffSettingsDomain",
    updateNotificationPreferences: "NotificationsDomain",
    startStripeConnectedAccountOnboarding: "PaymentsDomain",
    completeStripeConnectedAccountOnboarding: "PaymentsDomain",
    updatePaymentControlPlane: "PaymentsDomain",
    startAssistantSpreadsheetBridgeAuth: "AssistantIntegrationsDomain",
    completeAssistantSpreadsheetBridgeAuth: "AssistantIntegrationsDomain",
    exportAssistantSpreadsheetToGoogleDrive: "AssistantIntegrationsDomain",
    upsertAssistantWorkflowDraft: "AssistantPlatformDomain",
    submitAssistantWorkflowForApproval: "AssistantPlatformDomain",
    reviewAssistantWorkflow: "AssistantPlatformDomain",
    mutateAssistantRun: "AssistantPlatformDomain",
    updateStaffUserRole: "StaffSettingsDomain",
    inviteStaffUser: "StaffSettingsDomain",
    resendStaffInvite: "StaffSettingsDomain",
    deactivateStaffUser: "StaffSettingsDomain",
    reactivateStaffUser: "StaffSettingsDomain",
    createStaffCode: "StaffSettingsDomain",
    rotateStaffCode: "StaffSettingsDomain",
    revokeStaffCode: "StaffSettingsDomain",
    addApprovedDomain: "StaffSettingsDomain",
    removeApprovedDomain: "StaffSettingsDomain",
    requestFinancialAidHistoricalImportUpload: "StaffSettingsDomain",
    startFinancialAidHistoricalImport: "StaffSettingsDomain",
    markAllNotificationsRead: "NotificationsDomain",
    requestFamilyDocumentUpload: "StudentsFamiliesDomain",
    createFamilyNote: "StudentsFamiliesDomain",
    createFaculty: "FacultyDomain",
    updateFaculty: "FacultyDomain",
    addFacultyAssignment: "FacultyDomain",
    exportFacultyDirectory: "FacultyDomain",
    requestFacultyAssetUpload: "FacultyDomain",
    addFacultyNote: "FacultyDomain",
    sendFacultyCommunication: "FacultyDomain",
    createFamilyBillingEntry: "StudentsFamiliesDomain",
    createBulkCharge: "StudentsFamiliesDomain",
    createFamilyDocumentRecord: "StudentsFamiliesDomain",
    createAdHocCharge: "StudentsFamiliesDomain",
    archiveAdHocTuitionCharge: "StudentsFamiliesDomain",
    assignRecurringFee: "StudentsFamiliesDomain",
    unassignRecurringFee: "StudentsFamiliesDomain",
    bulkAssignRecurringFee: "StudentsFamiliesDomain",
    reverseTuitionPayment: "StudentsFamiliesDomain",
    issueTuitionRefund: "StudentsFamiliesDomain",
    mutateAssistantReportTemplate: "AssistantPlatformDomain",
    mutateAssistantReportSchedule: "AssistantPlatformDomain",
  });

export const ystnjKnownAwsJsonFieldShapes: Readonly<
  Record<string, YstnjAwsJsonFieldShapeMap>
> = Object.freeze({
  askSchoolAI: {
    conversationHistory: "array",
    context: "object",
    runtimePreferences: "object",
    routingHints: "object",
  },
  askAdmissionsAI: {
    conversationHistory: "array",
    context: "object",
    runtimePreferences: "object",
    routingHints: "object",
  },
  previewAssistantAction: {
    context: "object",
  },
  executeAssistantAction: {
    context: "object",
  },
});
